import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.home');
import { HostListener, OnDestroy, OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-home',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.home/view.scss */
:host {
  display: block;
  height: 100%;
  min-height: 100%;
}

.library-shell {
  --archive-ink: #173b36;
  --archive-green: #2f625a;
  --archive-copper: #a5632f;
  --archive-paper: #f6f7f5;
  background: radial-gradient(circle at 12% 4%, rgba(47, 98, 90, 0.055), transparent 25rem), linear-gradient(180deg, #f8f9f7 0, var(--archive-paper) 36rem, #f3f5f4 100%);
  font-family: Pretendard, "Noto Sans KR", "Apple SD Gothic Neo", system-ui, sans-serif;
}

.library-container {
  width: min(100%, 1340px);
  margin-inline: auto;
}

.library-header {
  position: sticky;
  top: 0;
  z-index: 40;
  backdrop-filter: blur(14px);
}

.library-logo-lockup {
  border-radius: 10px;
}

.library-logo-lockup:focus-visible {
  outline: 2px solid var(--archive-green);
  outline-offset: 5px;
}

.primary-action,
.search-submit {
  background: linear-gradient(135deg, #2d5d55 0%, var(--archive-ink) 100%);
  box-shadow: 0 7px 18px rgba(23, 59, 54, 0.18);
  transition: box-shadow 180ms ease, transform 180ms ease, background-color 180ms ease;
}

.primary-action:hover,
.search-submit:hover {
  box-shadow: 0 9px 22px rgba(23, 59, 54, 0.25);
  transform: translateY(-1px);
}

.account-trigger {
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.045);
  transition: border-color 180ms ease, box-shadow 180ms ease, background-color 180ms ease;
}

.account-trigger:hover,
.account-trigger[aria-expanded=true] {
  border-color: #b7c3c0;
  background: #fafcfb;
  box-shadow: 0 5px 16px rgba(15, 23, 42, 0.075);
}

.search-hero {
  background: linear-gradient(115deg, rgba(255, 255, 255, 0.93), rgba(244, 248, 246, 0.9)), repeating-linear-gradient(90deg, transparent 0, transparent 47px, rgba(47, 98, 90, 0.026) 48px);
}

.search-card {
  box-shadow: 0 16px 40px rgba(23, 59, 54, 0.075), 0 2px 6px rgba(15, 23, 42, 0.04);
}

.search-field {
  box-shadow: inset 0 0 0 1px #e2e8f0;
  transition: box-shadow 180ms ease, background-color 180ms ease;
}

.search-field:focus-within {
  background: #ffffff;
  box-shadow: inset 0 0 0 2px var(--archive-green), 0 0 0 4px rgba(47, 98, 90, 0.08);
}

.search-field.is-searching {
  background: #fbfdfc;
  box-shadow: inset 0 0 0 2px rgba(47, 98, 90, 0.55), 0 0 0 4px rgba(47, 98, 90, 0.06);
}

.search-submit:disabled {
  cursor: wait;
  opacity: 0.9;
}

.search-submit:disabled:hover {
  box-shadow: 0 7px 18px rgba(23, 59, 54, 0.18);
  transform: none;
}

.search-progress-panel {
  box-shadow: 0 10px 30px rgba(23, 59, 54, 0.09);
  animation: search-progress-enter 180ms ease-out both;
}

.search-progress-spinner,
.search-button-spinner {
  display: inline-block;
  border: 2px solid rgba(47, 98, 90, 0.2);
  border-top-color: #2f625a;
  border-radius: 999px;
  animation: search-spinner 800ms linear infinite;
}

.search-progress-spinner {
  width: 22px;
  height: 22px;
}

.search-button-spinner {
  width: 16px;
  height: 16px;
  border-color: rgba(255, 255, 255, 0.35);
  border-top-color: #ffffff;
}

.search-progress-track {
  height: 4px;
  overflow: hidden;
  background: #e5efec;
}

.search-progress-bar {
  display: block;
  width: 42%;
  height: 100%;
  border-radius: 999px;
  background: linear-gradient(90deg, #7db0a6, #2f625a 55%, #a5632f);
  animation: search-progress-sweep 1.35s ease-in-out infinite;
}

.search-progress-step {
  display: flex;
  min-width: 0;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 9px 12px;
  color: #8a9b97;
  font-size: 11px;
  font-weight: 700;
}

.search-progress-step + .search-progress-step {
  border-left: 1px solid #e3ece9;
}

.search-progress-step-dot {
  display: inline-flex;
  width: 19px;
  height: 19px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border: 1px solid #cad8d4;
  border-radius: 999px;
  background: #ffffff;
  font-size: 10px;
}

.search-progress-step.is-active {
  color: #244d47;
}

.search-progress-step.is-active .search-progress-step-dot {
  border-color: #2f625a;
  background: #2f625a;
  color: #ffffff;
  box-shadow: 0 0 0 4px rgba(47, 98, 90, 0.1);
}

.search-progress-step.is-complete {
  color: #55736d;
}

.search-progress-step.is-complete .search-progress-step-dot {
  border-color: #9ebbb4;
  background: #dcebe7;
  color: #315c55;
}

.result-toolbar button:disabled,
.result-toolbar select:disabled {
  cursor: wait;
  opacity: 0.5;
}

@keyframes search-spinner {
  to {
    transform: rotate(360deg);
  }
}
@keyframes search-progress-sweep {
  from {
    transform: translateX(-110%);
  }
  to {
    transform: translateX(260%);
  }
}
@keyframes search-progress-enter {
  from {
    opacity: 0;
    transform: translateY(-4px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
.quick-link {
  position: relative;
  transition: color 160ms ease;
}

.quick-link::before {
  display: inline-block;
  width: 3px;
  height: 3px;
  margin-right: 7px;
  border-radius: 999px;
  background: #c3cbc9;
  vertical-align: middle;
  content: "";
}

.quick-link:hover {
  color: var(--archive-ink);
}

.advanced-trigger {
  box-shadow: 0 2px 8px rgba(15, 23, 42, 0.04);
  transition: color 160ms ease, border-color 160ms ease, background-color 160ms ease;
}

.advanced-trigger:hover,
.advanced-trigger[aria-expanded=true] {
  border-color: #9aafa9;
  background: #f7faf9;
  color: var(--archive-ink);
}

.boolean-search-builder {
  box-shadow: 0 5px 16px rgba(15, 23, 42, 0.035);
}

.advanced-directory-grid {
  display: grid;
  gap: 12px;
}

.boolean-search-row {
  display: grid;
  grid-template-columns: 112px minmax(0, 1fr) 44px;
  gap: 10px;
  align-items: center;
}

.boolean-search-leading {
  display: flex;
  height: 44px;
  align-items: center;
  justify-content: center;
  border-radius: 6px;
  background: #eef4f2;
  color: #2f625a;
  font-size: 12px;
  font-weight: 800;
}

.xml-index-search {
  box-shadow: 0 5px 16px rgba(15, 23, 42, 0.035);
}

.index-type-grid {
  display: grid;
  grid-template-columns: repeat(4, minmax(0, 1fr));
  gap: 8px;
}

.index-type-option {
  display: flex;
  min-width: 0;
  min-height: 40px;
  cursor: pointer;
  align-items: center;
  gap: 8px;
  border: 1px solid #dbe3e1;
  border-radius: 8px;
  background: #f8faf9;
  padding: 8px 10px;
  color: #475569;
  font-size: 12px;
  font-weight: 800;
  transition: border-color 160ms ease, background-color 160ms ease, color 160ms ease;
}

.index-type-option.is-selected {
  border-color: #7f9f97;
  background: #eef5f2;
  color: #244d47;
}

.index-type-count {
  display: inline-flex;
  min-width: 24px;
  height: 22px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #e2e8e6;
  padding: 0 7px;
  color: #52645f;
  font-size: 10px;
  font-weight: 900;
}

.index-match-list {
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
}

.index-match-chip {
  display: inline-flex;
  max-width: 100%;
  align-items: center;
  gap: 5px;
  overflow: hidden;
  border: 1px solid #d9e5e1;
  border-radius: 999px;
  background: #f3f8f6;
  padding: 4px 8px;
  color: #365b54;
  font-size: 11px;
  font-weight: 800;
  line-height: 1.25;
}

.index-match-type {
  flex: 0 0 auto;
  color: #8a5a32;
}

.index-match-chip > span:last-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.category-rail {
  box-shadow: 0 4px 16px rgba(15, 23, 42, 0.025);
}

.category-navigation {
  min-width: 0;
}

.category-tabs-desktop {
  display: none;
  min-width: 0;
  align-items: stretch;
}

.category-tab {
  position: relative;
  display: inline-flex;
  min-width: 0;
  height: 60px;
  flex: 0 0 auto;
  align-items: center;
  gap: 8px;
  border: 0;
  background: transparent;
  padding: 0 clamp(10px, 1.25vw, 18px);
  color: #64748b;
  font-size: 13px;
  font-weight: 800;
  white-space: nowrap;
  transition: color 160ms ease, background-color 160ms ease;
}

.category-tab > span:first-child {
  overflow: hidden;
  max-width: 104px;
  text-overflow: ellipsis;
}

.category-tab::after {
  position: absolute;
  right: 12px;
  bottom: 0;
  left: 12px;
  height: 3px;
  border-radius: 999px 999px 0 0;
  background: var(--archive-green);
  opacity: 0;
  transform: scaleX(0.5);
  transition: opacity 180ms ease, transform 180ms ease;
  content: "";
}

.category-tab:hover {
  background: #fafcfb;
  color: #334155;
}

.category-tab.is-active {
  color: #0f2925;
}

.category-tab.is-active::after {
  opacity: 1;
  transform: scaleX(1);
}

.category-menu-shell {
  position: relative;
  display: flex;
  flex: 0 0 auto;
  height: 60px;
  align-items: center;
  margin-left: auto;
  padding-left: 24px;
}

.category-menu-shell::before {
  position: absolute;
  left: 10px;
  width: 1px;
  height: 24px;
  background: #e2e8e6;
  content: "";
}

.category-menu-trigger {
  display: inline-flex;
  height: 40px;
  align-items: center;
  gap: 8px;
  border: 1px solid #d9e2df;
  border-radius: 11px;
  background: #ffffff;
  padding: 0 11px 0 14px;
  color: #425a55;
  font-size: 12px;
  font-weight: 900;
  white-space: nowrap;
  box-shadow: 0 2px 7px rgba(15, 23, 42, 0.025);
  transition: border-color 160ms ease, background-color 160ms ease, box-shadow 160ms ease;
}

.category-menu-trigger:hover,
.category-menu-trigger.is-active {
  border-color: #8fa9a2;
  background: #f8fbfa;
  box-shadow: 0 0 0 3px rgba(47, 98, 90, 0.08);
  color: var(--archive-ink);
}

.category-menu-trigger svg {
  width: 15px;
  height: 15px;
  color: #78908a;
  transition: transform 180ms ease;
}

.category-menu-trigger svg.is-open {
  transform: rotate(180deg);
}

.category-menu-total {
  display: inline-flex;
  min-width: 22px;
  height: 20px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #eef3f1;
  padding: 0 6px;
  color: #607872;
  font-size: 10px;
}

.category-dropdown-menu {
  position: absolute;
  z-index: 45;
  top: calc(100% - 2px);
  right: 0;
  width: min(390px, 100vw - 32px);
  visibility: hidden;
  border: 1px solid #dce5e2;
  border-radius: 16px;
  background: #ffffff;
  padding: 10px;
  opacity: 0;
  box-shadow: 0 22px 60px rgba(18, 48, 42, 0.18);
  transform: translateY(-5px) scale(0.985);
  transform-origin: top right;
  transition: visibility 0s linear 160ms, opacity 160ms ease, transform 160ms ease;
  pointer-events: none;
}

.category-dropdown-menu.is-open {
  visibility: visible;
  opacity: 1;
  transform: translateY(0) scale(1);
  transition-delay: 0s;
  pointer-events: auto;
}

.category-dropdown-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  border-bottom: 1px solid #edf1f0;
  padding: 7px 8px 11px;
}

.category-dropdown-head div {
  display: flex;
  flex-direction: column;
  gap: 2px;
}

.category-dropdown-head strong {
  color: #1e3531;
  font-size: 13px;
}

.category-dropdown-head span {
  color: #85938f;
  font-size: 10px;
  font-style: normal;
  font-weight: 700;
}

.category-dropdown-actions {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 8px 8px 2px;
}

.category-dropdown-actions button {
  border: 0;
  background: transparent;
  padding: 0;
  color: var(--archive-green);
  font-size: 10px;
  font-weight: 900;
}

.category-dropdown-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 5px;
  padding-top: 8px;
}

.category-dropdown-item {
  display: grid;
  min-width: 0;
  min-height: 50px;
  grid-template-columns: 17px minmax(0, 1fr) auto;
  align-items: center;
  gap: 8px;
  border: 1px solid transparent;
  border-radius: 10px;
  background: transparent;
  padding: 0 9px;
  color: #52645f;
  font-size: 12px;
  font-weight: 800;
  text-align: left;
  transition: border-color 140ms ease, background-color 140ms ease, color 140ms ease;
}

.category-option-check {
  display: inline-flex;
  width: 17px;
  height: 17px;
  align-items: center;
  justify-content: center;
  border: 1px solid #cbd7d3;
  border-radius: 5px;
  background: #ffffff;
  color: #ffffff;
}

.category-option-check svg {
  width: 12px;
  height: 12px;
}

.category-dropdown-item.is-active .category-option-check {
  border-color: var(--archive-green);
  background: var(--archive-green);
}

.category-option-label {
  display: flex;
  min-width: 0;
  flex-direction: column;
  gap: 1px;
  overflow: hidden;
}

.category-option-label strong,
.category-option-label small {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.category-option-label strong {
  color: inherit;
  font-size: 12px;
  line-height: 1.25;
}

.category-option-label small {
  color: #8a9894;
  font-size: 10px;
  font-weight: 700;
  line-height: 1.2;
}

.category-dropdown-item em {
  display: inline-flex;
  min-width: 24px;
  height: 21px;
  flex: 0 0 auto;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #f0f3f2;
  padding: 0 6px;
  color: #82908d;
  font-size: 10px;
  font-style: normal;
}

.category-dropdown-item:hover {
  background: #f6f9f8;
  color: #1f3c37;
}

.category-dropdown-item.is-active {
  border-color: #bfd3cd;
  background: #eaf3f0;
  color: var(--archive-ink);
}

.category-dropdown-item.is-active em {
  background: #ffffff;
  color: var(--archive-green);
}

.category-picker-mobile {
  display: grid;
  grid-template-columns: auto minmax(0, 1fr);
  align-items: center;
  gap: 12px;
  padding: 11px 0;
  color: #435651;
  font-size: 12px;
  font-weight: 900;
}

.category-picker-mobile select {
  height: 42px;
  padding: 0 34px 0 13px;
}

.category-count,
.quick-category-count {
  display: inline-flex;
  min-width: 23px;
  height: 22px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #f0f3f2;
  padding-inline: 7px;
  color: #82908d;
  font-size: 11px;
  line-height: 1;
}

.category-tab.is-active .category-count {
  background: #e6f0ed;
  color: var(--archive-green);
}

.filter-panel {
  display: none;
  box-shadow: 0 10px 28px rgba(15, 23, 42, 0.045);
}

.filter-panel.is-open {
  display: block;
}

.filter-panel-header {
  display: flex;
  min-height: 76px;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  border-bottom: 1px solid #dfe5e3;
  padding: 15px 20px 13px;
}

.filter-panel-header h2 {
  margin: 2px 0 0;
  color: #111827;
  font-size: 20px;
  font-weight: 900;
  letter-spacing: -0.035em;
}

.filter-panel-eyebrow {
  color: #a5632f;
  font-size: 9px;
  font-weight: 900;
  letter-spacing: 0.14em;
  text-transform: uppercase;
}

.filter-reset {
  height: 30px;
  border: 1px solid #d9e2df;
  border-radius: 8px;
  background: #ffffff;
  padding: 0 9px;
  color: #8a5a36;
  font-size: 10px;
  font-weight: 800;
}

.filter-reset:hover {
  border-color: #c5d1cd;
  background: #f8faf9;
}

.filter-accordion-section {
  border-bottom: 1px solid #dfe5e3;
}

.filter-accordion-section:last-child {
  border-bottom: 0;
}

.filter-accordion-trigger {
  display: grid;
  width: 100%;
  min-height: 62px;
  grid-template-columns: minmax(0, 1fr) auto 18px;
  align-items: center;
  gap: 8px;
  border: 0;
  background: #ffffff;
  padding: 0 18px 0 20px;
  color: #202624;
  text-align: left;
  transition: background-color 180ms ease, color 180ms ease;
}

.filter-accordion-trigger > span:first-child {
  font-size: 14px;
  font-weight: 900;
  letter-spacing: -0.02em;
}

.filter-accordion-trigger:hover,
.filter-accordion-trigger.is-open {
  background: #fafcfb;
  color: var(--archive-green);
}

.filter-accordion-trigger svg {
  width: 17px;
  height: 17px;
  color: #4f5e5a;
  transition: transform 280ms cubic-bezier(0.22, 1, 0.36, 1);
}

.filter-accordion-trigger.is-open svg {
  transform: rotate(180deg);
}

.filter-section-value {
  overflow: hidden;
  max-width: 92px;
  color: #94a09d;
  font-size: 10px;
  font-weight: 800;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.filter-section-value.has-value {
  border-radius: 999px;
  background: #eaf3f0;
  padding: 4px 7px;
  color: var(--archive-green);
}

.filter-accordion-collapse {
  display: grid;
  visibility: hidden;
  grid-template-rows: 0fr;
  opacity: 0;
  transition: grid-template-rows 300ms cubic-bezier(0.22, 1, 0.36, 1), opacity 200ms ease, visibility 0s linear 300ms;
  pointer-events: none;
}

.filter-accordion-collapse.is-open {
  visibility: visible;
  grid-template-rows: 1fr;
  opacity: 1;
  transition-delay: 0s;
  pointer-events: auto;
}

.filter-accordion-inner {
  min-height: 0;
  overflow: hidden;
}

.filter-accordion-body {
  border-top: 1px solid #edf1f0;
  background: #f8faf9;
  padding: 15px 16px 17px;
  transform: translateY(-6px);
  transition: transform 300ms cubic-bezier(0.22, 1, 0.36, 1);
}

.filter-accordion-collapse.is-open .filter-accordion-body {
  transform: translateY(0);
}

.filter-field {
  display: block;
  margin-bottom: 11px;
}

.filter-field > span {
  display: block;
  margin-bottom: 5px;
  color: #71817d;
  font-size: 10px;
  font-weight: 900;
}

.filter-custom-select {
  position: relative;
}

.filter-select-trigger {
  display: flex;
  width: 100%;
  height: 42px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border: 1px solid #d4dfdc;
  border-radius: 10px;
  background: #ffffff;
  padding: 0 11px 0 13px;
  color: #2f423e;
  font-size: 12px;
  font-weight: 800;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.02);
  transition: border-color 160ms ease, box-shadow 160ms ease, background-color 160ms ease;
}

.filter-select-trigger:hover,
.filter-select-trigger.is-open {
  border-color: #8fa9a2;
  background: #fbfdfc;
  box-shadow: 0 0 0 3px rgba(47, 98, 90, 0.08);
}

.filter-select-trigger svg {
  width: 15px;
  height: 15px;
  flex: 0 0 auto;
  color: #718681;
  transition: transform 220ms ease;
}

.filter-select-trigger.is-open svg {
  transform: rotate(180deg);
}

.filter-select-menu {
  display: grid;
  visibility: hidden;
  grid-template-rows: 0fr;
  opacity: 0;
  transition: grid-template-rows 220ms cubic-bezier(0.22, 1, 0.36, 1), opacity 160ms ease, visibility 0s linear 220ms;
  pointer-events: none;
}

.filter-select-menu.is-open {
  visibility: visible;
  grid-template-rows: 1fr;
  opacity: 1;
  transition-delay: 0s;
  pointer-events: auto;
}

.filter-select-menu-inner {
  display: grid;
  min-height: 0;
  max-height: 190px;
  gap: 3px;
  overflow-y: auto;
  border: 1px solid transparent;
  border-radius: 11px;
  background: #ffffff;
  padding: 0 5px;
  box-shadow: none;
  scrollbar-color: #c7d3cf transparent;
  scrollbar-width: thin;
  transition: margin-top 220ms ease, padding 220ms ease, border-color 220ms ease, box-shadow 220ms ease;
}

.filter-select-menu.is-open .filter-select-menu-inner {
  margin-top: 6px;
  border-color: #d9e3e0;
  padding-block: 5px;
  box-shadow: 0 10px 24px rgba(22, 54, 48, 0.1);
}

.filter-select-option {
  display: flex;
  min-height: 36px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border: 0;
  border-radius: 8px;
  background: transparent;
  padding: 0 9px;
  color: #536560;
  font-size: 11px;
  font-weight: 800;
  text-align: left;
  transition: background-color 140ms ease, color 140ms ease;
}

.filter-select-option:hover {
  background: #f3f7f5;
  color: #1f3d37;
}

.filter-select-option.is-selected {
  background: #eaf3f0;
  color: var(--archive-green);
}

.filter-select-option svg {
  width: 14px;
  height: 14px;
  flex: 0 0 auto;
}

.filter-select,
.filter-input {
  display: block;
  width: 100%;
  height: 42px;
  border: 1px solid #d4dfdc;
  border-radius: 10px;
  background-color: #ffffff;
  color: #2f423e;
  font-size: 12px;
  font-weight: 800;
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.02);
}

.filter-select {
  padding-left: 12px;
}

.filter-select:hover,
.filter-input:hover {
  border-color: #9eb2ac;
}

.filter-select:focus,
.filter-input:focus {
  border-color: var(--archive-green);
  box-shadow: 0 0 0 3px rgba(47, 98, 90, 0.1);
  outline: none;
}

.metadata-result-card {
  display: flex;
  min-height: 42px;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  border-radius: 10px;
  padding: 0 11px;
}

.metadata-result-card {
  margin-top: 2px;
  background: #eaf3f0;
  color: #607570;
  font-size: 10px;
  font-weight: 900;
}

.metadata-result-card strong {
  color: var(--archive-green);
  font-size: 13px;
}

.filter-input-wrap {
  position: relative;
}

.filter-input-wrap svg {
  position: absolute;
  z-index: 1;
  top: 13px;
  left: 12px;
  width: 16px;
  height: 16px;
  color: #879792;
  pointer-events: none;
}

.filter-input {
  padding: 0 12px 0 37px;
}

.filter-help {
  margin: 8px 2px 0;
  color: #8a9794;
  font-size: 10px;
  font-weight: 700;
}

.category-multi-actions {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
  margin-bottom: 9px;
  color: #7a8a86;
  font-size: 10px;
  font-weight: 800;
}

.category-multi-actions div {
  display: flex;
  gap: 8px;
}

.category-multi-actions button {
  border: 0;
  background: transparent;
  padding: 0;
  color: var(--archive-green);
  font-size: 10px;
  font-weight: 900;
}

.category-multi-list {
  display: grid;
  gap: 5px;
}

.category-multi-option {
  display: grid;
  min-height: 38px;
  cursor: pointer;
  grid-template-columns: 16px minmax(0, 1fr) auto;
  align-items: center;
  gap: 9px;
  border: 1px solid transparent;
  border-radius: 9px;
  padding: 5px 8px;
  color: #536560;
  font-size: 12px;
  font-weight: 800;
  transition: border-color 150ms ease, background-color 150ms ease, color 150ms ease;
}

.category-multi-option:hover {
  background: #f1f5f3;
}

.category-multi-option.is-selected {
  border-color: #bed3cd;
  background: #eaf3f0;
  color: var(--archive-ink);
}

.category-multi-option input {
  width: 16px;
  height: 16px;
  border-radius: 4px;
  accent-color: var(--archive-green);
}

.category-multi-option em {
  display: inline-flex;
  min-width: 24px;
  height: 21px;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: #ffffff;
  padding: 0 6px;
  color: #7a8c87;
  font-size: 10px;
  font-style: normal;
}

.search-field input[type=search]::-webkit-search-cancel-button {
  display: none;
}

.result-preview {
  background: linear-gradient(135deg, #eef5f2, #f4f8f6);
}

.filter-radio {
  display: flex;
  min-height: 34px;
  cursor: pointer;
  align-items: center;
  gap: 9px;
  border-radius: 9px;
  padding: 6px 8px;
  transition: background-color 150ms ease, color 150ms ease;
}

.filter-radio:hover {
  background: #f5f8f7;
  color: #1f3f3a;
}

.quick-category {
  display: flex;
  width: 100%;
  min-height: 38px;
  align-items: center;
  justify-content: space-between;
  border: 1px solid transparent;
  border-radius: 10px;
  padding: 7px 9px 7px 11px;
  color: #52616f;
  font-size: 12px;
  font-weight: 700;
  text-align: left;
  transition: border-color 150ms ease, background-color 150ms ease, color 150ms ease;
}

.quick-category:hover {
  background: #f7f9f8;
  color: #243d39;
}

.quick-category.is-active {
  border-color: #c7d9d4;
  background: #eef5f2;
  color: var(--archive-ink);
}

.quick-category.is-active .quick-category-count {
  background: #ffffff;
  color: var(--archive-green);
}

.result-toolbar {
  box-shadow: 0 8px 24px rgba(15, 23, 42, 0.04);
}

.toolbar-select {
  height: 36px;
  border: 1px solid #dbe2e0;
  border-radius: 9px;
  background: #ffffff;
  padding: 0 10px;
  color: #475569;
  font-size: 12px;
  font-weight: 700;
}

.toolbar-check {
  transition: border-color 150ms ease, background-color 150ms ease;
}

.toolbar-check:hover {
  border-color: #b8c6c2;
  background: #fafcfb;
}

.filter-chip {
  display: inline-flex;
  max-width: 250px;
  min-height: 29px;
  align-items: center;
  gap: 7px;
  border: 1px solid #d5e2de;
  border-radius: 999px;
  background: #f3f8f6;
  padding: 5px 9px 5px 11px;
  color: #315c55;
  font-size: 11px;
  font-weight: 700;
  transition: border-color 150ms ease, background-color 150ms ease;
}

.filter-chip span:first-child {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.filter-chip:hover {
  border-color: #aec6bf;
  background: #eaf3f0;
}

.catalog-skeleton,
.empty-state,
.pagination {
  box-shadow: 0 6px 20px rgba(15, 23, 42, 0.035);
}

.catalog-card,
.cover-card {
  box-shadow: 0 5px 18px rgba(15, 23, 42, 0.035);
  transition: border-color 200ms ease, box-shadow 200ms ease, transform 200ms ease;
}

.catalog-card:hover,
.cover-card:hover {
  border-color: #bac9c5;
  box-shadow: 0 16px 36px rgba(23, 59, 54, 0.09);
  transform: translateY(-2px);
}

.catalog-card:focus-visible,
.cover-card:focus-visible {
  border-color: var(--archive-green);
  box-shadow: 0 0 0 3px rgba(47, 98, 90, 0.12), 0 16px 36px rgba(23, 59, 54, 0.08);
  outline: none;
}

.catalog-card.is-selected,
.cover-card.is-selected {
  border-color: #78a99f;
  background: #f7fbfa;
  box-shadow: 0 0 0 2px rgba(47, 98, 90, 0.1), 0 12px 28px rgba(23, 59, 54, 0.08);
}

.selection-control {
  transition: border-color 150ms ease, background-color 150ms ease, box-shadow 150ms ease;
}

.selection-control:hover {
  border-color: #9dbdb6;
  background: #f4f9f7;
}

.bulk-actions {
  min-height: 52px;
}

.catalog-cover {
  border: 1px solid rgba(148, 163, 184, 0.18);
  box-shadow: 0 9px 20px rgba(15, 23, 42, 0.13);
}

.catalog-cover img {
  transition: transform 350ms cubic-bezier(0.22, 1, 0.36, 1);
}

.catalog-card:hover .catalog-cover img,
.cover-card:hover .catalog-cover img {
  transform: scale(1.025);
}

.catalog-title {
  transition: color 160ms ease;
}

.catalog-card:hover .catalog-title {
  color: var(--archive-ink);
}

.material-badge,
.meta-badge,
.visibility-badge {
  display: inline-flex;
  height: 24px;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 7px;
  padding-inline: 8px;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.01em;
}

.material-badge {
  background: #eee9e2;
  color: #755236;
}

.meta-badge {
  background: #f1f4f6;
  color: #64748b;
}

.visibility-badge.is-public {
  border-color: #c8ddd7;
  background: #eaf3f0;
  color: #286158;
}

.visibility-badge.is-private {
  border-color: #ead5ad;
  background: #fbf1df;
  color: #8a5b1f;
}

.semantic-result-badge {
  display: inline-flex;
  height: 24px;
  align-items: center;
  border: 1px solid #d7c4ae;
  border-radius: 7px;
  background: #fbf5ed;
  padding-inline: 8px;
  color: #8b5a2b;
  font-size: 10px;
  font-weight: 800;
}

:host ::ng-deep .catalog-card mark,
:host ::ng-deep .cover-card mark {
  border-radius: 3px;
  background: #fde68a;
  box-decoration-break: clone;
  color: inherit;
  padding: 0 0.08em;
  -webkit-box-decoration-break: clone;
}

.secondary-link,
.primary-link {
  display: inline-flex;
  height: 32px;
  align-items: center;
  border-radius: 8px;
  padding-inline: 11px;
  font-size: 11px;
  font-weight: 800;
  transition: border-color 150ms ease, background-color 150ms ease, color 150ms ease;
}

.secondary-link {
  border: 1px solid #d9e0df;
  background: #ffffff;
  color: #596875;
}

.secondary-link:hover {
  border-color: #acbcb8;
  background: #f8faf9;
  color: var(--archive-ink);
}

.primary-link {
  border: 1px solid var(--archive-ink);
  background: var(--archive-ink);
  color: #ffffff;
}

.primary-link:hover {
  border-color: #0e2c28;
  background: #0e2c28;
}

.detail-cue svg {
  transition: transform 160ms ease;
}

.catalog-card:hover .detail-cue {
  color: var(--archive-green);
}

.catalog-card:hover .detail-cue svg {
  transform: translateX(2px);
}

.cover-card-visual {
  border-bottom: 1px solid #e7ecea;
  background: radial-gradient(circle at 50% 42%, rgba(255, 255, 255, 0.96), rgba(239, 243, 241, 0.93)), linear-gradient(135deg, #eef2f0, #f8f8f5);
}

.page-button,
.page-number {
  display: inline-flex;
  height: 34px;
  min-width: 34px;
  align-items: center;
  justify-content: center;
  border: 1px solid #dce3e1;
  border-radius: 9px;
  background: #ffffff;
  padding-inline: 10px;
  color: #64748b;
  font-size: 11px;
  font-weight: 800;
  transition: border-color 150ms ease, background-color 150ms ease, color 150ms ease;
}

.page-button:hover:not(:disabled),
.page-number:hover:not(.is-active) {
  border-color: #afc0bc;
  background: #f7faf9;
  color: var(--archive-ink);
}

.page-number.is-active {
  border-color: var(--archive-ink);
  background: var(--archive-ink);
  color: #ffffff;
}

.page-button:disabled {
  cursor: not-allowed;
  opacity: 0.38;
}

pre {
  tab-size: 2;
  white-space: pre-wrap;
  word-break: break-word;
}

button,
a,
input,
select {
  outline-offset: 2px;
}

select {
  appearance: none;
  -webkit-appearance: none;
  padding-right: 36px !important;
  background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='16' height='16' viewBox='0 0 24 24' fill='none' stroke='%23647874' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='m6 9 6 6 6-6'/%3E%3C/svg%3E");
  background-repeat: no-repeat;
  background-position: right 11px center;
  background-size: 16px;
  transition: border-color 160ms ease, background-color 160ms ease, box-shadow 160ms ease;
}

select:hover {
  border-color: #9bb0aa;
  background-color: #f9fbfa;
}

select:focus-visible {
  border-color: var(--archive-green);
  box-shadow: 0 0 0 3px rgba(47, 98, 90, 0.1);
  outline: none;
}

select:disabled {
  cursor: not-allowed;
  opacity: 0.55;
}

select option {
  background: #ffffff;
  color: #334155;
  font-weight: 600;
}

button:not(:disabled),
select:not(:disabled) {
  cursor: pointer;
}

button:focus-visible,
a:focus-visible {
  outline: 2px solid var(--archive-green);
  outline-offset: 3px;
}

.line-clamp-2,
.line-clamp-3 {
  display: -webkit-box;
  -webkit-box-orient: vertical;
  overflow: hidden;
}

.line-clamp-2 {
  -webkit-line-clamp: 2;
}

.line-clamp-3 {
  -webkit-line-clamp: 3;
}

.account-menu-chevron {
  transition: transform 200ms ease;
}

.account-menu-chevron.is-open {
  transform: rotate(180deg);
}

.account-dropdown-menu {
  visibility: hidden;
  opacity: 0;
  pointer-events: none;
  transform: translateY(-8px) scale(0.98);
  transform-origin: top right;
  transition: opacity 200ms ease, transform 200ms cubic-bezier(0.22, 1, 0.36, 1), visibility 0s linear 200ms;
  will-change: opacity, transform;
}

.account-dropdown-menu.is-open {
  visibility: visible;
  opacity: 1;
  pointer-events: auto;
  transform: translateY(0) scale(1);
  transition-delay: 0s;
}

.view-mode-toggle {
  position: relative;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  overflow: hidden;
  width: 126px;
  height: 36px;
  border: 1px solid #dbe2e0;
  border-radius: 9px;
  background: #f4f6f5;
}

.view-mode-indicator {
  position: absolute;
  inset: 0 auto 0 0;
  width: 50%;
  background: var(--archive-ink);
  transform: translateX(0);
  transition: transform 280ms cubic-bezier(0.22, 1, 0.36, 1);
  will-change: transform;
}

.view-mode-indicator.is-cover {
  transform: translateX(100%);
}

.view-mode-button {
  position: relative;
  z-index: 1;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  border: 0;
  background: transparent;
  color: #475569;
  font-size: 11px;
  font-weight: 700;
  cursor: pointer;
  transition: color 180ms ease;
}

.view-mode-button.is-active {
  color: #ffffff;
}

.view-mode-button:not(.is-active):hover {
  color: #0f172a;
}

.view-mode-content {
  animation-duration: 260ms;
  animation-timing-function: cubic-bezier(0.22, 1, 0.36, 1);
  animation-fill-mode: both;
}

.view-mode-content.results-enter-a {
  animation-name: results-enter-a;
}

.view-mode-content.results-enter-b {
  animation-name: results-enter-b;
}

.modal-overlay-enter {
  backdrop-filter: blur(2px);
  animation: modal-overlay-enter 180ms ease-out both;
}

.modal-panel-enter {
  animation: modal-panel-enter 260ms cubic-bezier(0.22, 1, 0.36, 1) both;
  transform-origin: center top;
}

.delete-dialog-panel {
  box-shadow: 0 32px 80px rgba(15, 23, 42, 0.24), 0 8px 24px rgba(15, 23, 42, 0.1);
}

.delete-dialog-header {
  background: radial-gradient(circle at 92% 0%, rgba(254, 226, 226, 0.72), transparent 38%), linear-gradient(180deg, #ffffff 0%, #fdfdfd 100%);
}

.delete-dialog-stat {
  display: flex;
  min-width: 0;
  min-height: 76px;
  flex-direction: column;
  justify-content: space-between;
  gap: 10px;
  padding: 13px 14px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #f8fafc;
}

.delete-dialog-stat span {
  color: #64748b;
  font-size: 10px;
  font-weight: 800;
  letter-spacing: 0.02em;
}

.delete-dialog-stat strong {
  color: #172b28;
  font-size: 17px;
  font-weight: 850;
  line-height: 1;
}

.delete-dialog-button {
  display: inline-flex;
  min-height: 42px;
  align-items: center;
  justify-content: center;
  gap: 7px;
  padding: 0 18px;
  border: 1px solid transparent;
  border-radius: 11px;
  font-size: 13px;
  font-weight: 800;
  transition: border-color 160ms ease, background-color 160ms ease, color 160ms ease, transform 160ms ease;
}

.delete-dialog-button:not(:disabled):active {
  transform: translateY(1px);
}

.delete-dialog-button.is-secondary {
  border-color: #cbd5e1;
  background: #ffffff;
  color: #334155;
}

.delete-dialog-button.is-secondary:not(:disabled):hover {
  border-color: #94a3b8;
  background: #f8fafc;
}

.delete-dialog-button.is-danger {
  border-color: #dc2626;
  background: #dc2626;
  color: #ffffff;
  box-shadow: 0 8px 18px rgba(220, 38, 38, 0.18);
}

.delete-dialog-button.is-danger:not(:disabled):hover {
  border-color: #b91c1c;
  background: #b91c1c;
}

.delete-dialog-button:disabled {
  cursor: wait;
  opacity: 0.6;
}

.delete-dialog-spinner {
  width: 54px;
  height: 54px;
  border: 5px solid #e7efed;
  border-top-color: #2f625a;
  border-radius: 999px;
  animation: delete-dialog-spin 800ms linear infinite;
  box-shadow: 0 0 0 8px rgba(47, 98, 90, 0.05);
}

@keyframes results-enter-a {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes results-enter-b {
  from {
    opacity: 0;
    transform: translateY(6px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@keyframes modal-overlay-enter {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes modal-panel-enter {
  from {
    opacity: 0;
    transform: translateY(-10px) scale(0.985);
  }
  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}
@keyframes delete-dialog-spin {
  to {
    transform: rotate(360deg);
  }
}
@media (min-width: 960px) {
  .category-tabs-desktop {
    display: flex;
  }
  .category-picker-mobile {
    display: none;
  }
}
@media (min-width: 1024px) {
  .filter-panel {
    position: sticky;
    top: 98px;
    display: block;
    align-self: start;
    overflow: hidden;
  }
}
@media (min-width: 1280px) {
  .advanced-directory-grid {
    grid-template-columns: 140px repeat(3, minmax(0, 1fr));
  }
  .advanced-directory-grid.has-visibility-filter {
    grid-template-columns: 140px repeat(4, minmax(0, 1fr));
  }
}
@media (max-width: 639px) {
  .index-type-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  .boolean-search-row {
    grid-template-columns: 78px minmax(0, 1fr) 44px;
    gap: 7px;
  }
  .library-header {
    position: relative;
  }
  .search-card {
    border-radius: 14px;
  }
  .search-field {
    height: 50px;
  }
  .search-submit {
    padding-inline: 13px;
  }
  .catalog-card {
    padding: 14px;
  }
  .catalog-card .catalog-cover {
    width: 88px;
    height: 128px;
  }
  .catalog-card .material-badge,
  .catalog-card .meta-badge,
  .catalog-card .visibility-badge {
    height: 21px;
    padding-inline: 6px;
    font-size: 9px;
  }
  .active-filters .filter-chip {
    max-width: 210px;
  }
  .delete-dialog {
    align-items: flex-end;
    padding: 0;
  }
  .delete-dialog-panel {
    max-height: 94vh;
    border-right: 0;
    border-bottom: 0;
    border-left: 0;
    border-radius: 22px 22px 0 0;
  }
  .delete-dialog-button {
    width: 100%;
  }
}
@media (prefers-reduced-motion: reduce) {
  .account-menu-chevron,
  .account-dropdown-menu,
  .view-mode-indicator,
  .filter-accordion-trigger svg,
  .filter-accordion-collapse,
  .filter-accordion-body,
  .filter-select-trigger svg,
  .filter-select-menu,
  .filter-select-menu-inner {
    transition-duration: 0.01ms;
  }
  .view-mode-content,
  .modal-overlay-enter,
  .modal-panel-enter,
  .delete-dialog-spinner,
  .search-progress-panel,
  .search-progress-bar,
  .search-progress-spinner,
  .search-button-spinner {
    animation-duration: 0.01ms;
  }
  .primary-action,
  .search-submit,
  .catalog-card,
  .cover-card,
  .catalog-cover img {
    transition-duration: 0.01ms;
  }
}`],
})
export class PageHomeComponent implements OnInit, OnDestroy {
    private static initialSearchStateResolved: boolean = false;

    public loading: boolean = true;
    public libraryReady: boolean = false;
    public searchProgressStep: number = 0;
    public searchElapsedSeconds: number = 0;
    public readonly searchProgressSteps: string[] = [
        "검색 조건 확인",
        "자료·의미 검색",
        "결과 정리"
    ];
    public query: string = "";
    public advancedTitle: string = "";
    public advancedId: string = "";
    public advancedPublisher: string = "";
    public advancedAll: string = "";
    public advancedArticleTitle: string = "";
    public advancedContent: string = "";
    public advancedIndexTypes: string[] = [];
    public indexRows: any[] = [{ operator: "AND", keyword: "" }];
    public indexExpressionApplied: string = "";
    public advancedSubjectQuery: string = "";
    public advancedSender: string = "";
    public advancedDateFrom: string = "";
    public advancedDateTo: string = "";
    public advancedDirectoryCategory: string = "";
    public advancedDirectorySource: string = "";
    public advancedDirectoryOrganization: string = "";
    public booleanRows: any[] = [{ operator: "AND", keyword: "" }];
    public booleanExpressionApplied: string = "";
    public publisherFilter: string = "";
    public nodeFilter: string = "all";
    public eraFilter: string = "";
    public fileTypeFilter: string = "";
    public pdfFilter: string = "";
    public visibilityFilter: string = "all";
    public resultUnitFilter: string = "item";
    public scopeLevelFilter: string = "all";
    public metadataFilterMode: string = "AND";
    public activeCategory: string = "";
    public selectedCategories: string[] = [];
    public withinResults: boolean = false;
    public showHanja: boolean = true;
    public advancedOpen: boolean = false;
    public infoPanel: string = "";
    public viewMode: string = "list";
    public resultsAnimationFlip: boolean = false;
    public pageSize: number = 5;
    public currentPage: number = 1;
    public paginationLoadingPage: number | null = null;
    public sortKey: string = "recent";
    public items: any[] = [];
    public filteredItems: any[] = [];
    public displayItems: any[] = [];
    public selectedItemKeys: string[] = [];
    public deletingSelection: boolean = false;
    public deleteDialogOpen: boolean = false;
    public deleteDialogItems: any[] = [];
    public deleteDialogPhase: string = "confirm";
    public deleteDialogFailures: any[] = [];
    public deleteDialogWarnings: any[] = [];
    public deleteDialogError: string = "";
    public deleteDialogDeleted: number = 0;
    public deleteDialogAlreadyDeleted: number = 0;
    public deleteDialogRequestId: string = "";
    public totalResults: number = 0;
    public searchError: string = "";
    public searchStatus: any = {};
    public summary: any = {};
    public selectedItem: any = null;
    public detailOpen: boolean = false;
    public detailLoading: boolean = false;
    public detailTab: string = "summary";
    public detailXml: string = "";
    public documentDetail: any = {};
    public scrapbook: any[] = [];
    public scrapFolder: string = "기본 자료함";
    public scrapMemo: string = "";
    public accountMenuOpen: boolean = false;
    public categoryMenuOpen: boolean = false;
    public filterPanelOpen: boolean = false;
    public activeFilterSection: string = "";
    public activeMetadataDropdown: string = "";
    public citationCopied: boolean = false;
    public searchHistory: string[] = [];
    public popularKeywords: string[] = ["감계사등록", "고구려", "동문휘고", "독도", "한일관계", "고지도"];
    public categories: string[] = [];
    public sourceOptions: string[] = [];
    public organizationOptions: string[] = [];
    public eraOptions: string[] = [];
    public fileTypeOptions: string[] = [];
    public indexTypeOptions: any[] = [
        { id: "person", label: "인물", count: 0 },
        { id: "place", label: "지명", count: 0 },
        { id: "event", label: "사건", count: 0 },
        { id: "organization", label: "단체·기관", count: 0 },
        { id: "literature", label: "문헌", count: 0 },
        { id: "artifact", label: "유물·유적", count: 0 },
        { id: "subject", label: "주제어", count: 0 },
        { id: "other", label: "기타·미분류", count: 0 }
    ];
    public readonly visibilityOptions: any[] = [
        { value: "all", label: "전체" },
        { value: "published", label: "공개" },
        { value: "draft", label: "비공개" }
    ];
    public scrapFolders: string[] = ["기본 자료함", "검토 자료", "인용 후보", "공유 예정"];

    private readonly historyKey: string = "nahf-library-search-history";
    private readonly scrapKey: string = "nahf-library-scraps";
    private categorySelectionTimer: any = null;
    private searchProgressTimer: any = null;
    private libraryRequestSequence: number = 0;
    private authRedirecting: boolean = false;
    private lastAppliedQuery: string = "";
    private readonly pageSizeOptionsByMode: { [key: string]: number[] } = {
        list: [5, 10, 20],
        cover: [3, 6, 24]
    };
    private pageSizeByViewMode: { [key: string]: number } = {
        list: 5,
        cover: 3
    };

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        let authenticated = await this.service.auth.check();
        if (!authenticated) {
            this.redirectToLogin();
            return;
        }
        this.loadSearchHistory();
        this.loadScrapbook();
        this.initializeSearchState();
        await this.fetchLibraryPage(true);
    }

    public ngOnDestroy() {
        this.libraryRequestSequence += 1;
        this.stopSearchProgress();
    }

    public async reload() {
        await this.clearSearch();
    }

    public accountDisplayName() {
        const session = this.service.auth.session || {};
        return session.name || session.id || session.email || "User";
    }

    public async toggleAccountMenu() {
        this.categoryMenuOpen = false;
        this.activeMetadataDropdown = "";
        this.accountMenuOpen = !this.accountMenuOpen;
        await this.service.render();
    }

    public async closeAccountMenu() {
        this.accountMenuOpen = false;
        await this.service.render();
    }

    public async toggleCategoryMenu(event?: Event) {
        if (event) event.stopPropagation();
        this.accountMenuOpen = false;
        this.activeMetadataDropdown = "";
        this.categoryMenuOpen = !this.categoryMenuOpen;
        await this.service.render();
    }

    @HostListener('document:click')
    public async closeOpenMenusOnOutsideClick() {
        if (!this.accountMenuOpen && !this.categoryMenuOpen && !this.activeMetadataDropdown) return;
        this.accountMenuOpen = false;
        this.categoryMenuOpen = false;
        this.activeMetadataDropdown = "";
        await this.service.render();
    }

    @HostListener('document:keydown.escape')
    public async closeDeleteDialogOnEscape() {
        if (!this.deleteDialogOpen || this.deletingSelection) return;
        await this.closeDeleteDialog();
    }

    public async runSearch() {
        if (this.loading) return;
        this.applyWithinResultsQuery();
        this.addSearchHistory(this.currentSearchKeyword());
        await this.applySearch(true);
    }

    public async applyAdvanced() {
        const expression = this.buildBooleanExpression();
        this.query = expression || `${this.advancedAll || ""}`.trim();
        this.booleanExpressionApplied = expression;
        this.publisherFilter = `${this.advancedPublisher || ""}`.trim();
        if (
            this.selectedCategories.length === 0
            || this.advancedDirectoryCategory
        ) {
            this.activeCategory = this.advancedDirectoryCategory;
            this.selectedCategories = [];
        }
        this.indexExpressionApplied = this.buildIndexExpression();
        this.advancedOpen = false;
        await this.runSearch();
    }

    private applyWithinResultsQuery() {
        if (!this.withinResults) return;
        const previous = `${this.lastAppliedQuery || ""}`.trim();
        const current = `${this.query || ""}`.trim();
        if (!previous || !current || previous === current) return;
        this.query = `(${previous}) AND (${current})`;
        this.advancedAll = this.query;
    }

    public async applySearch(render: boolean = true, _source?: any[]) {
        this.clearSelection();
        this.currentPage = 1;
        await this.fetchLibraryPage(render);
    }

    private libraryParams() {
        const scopedQuery = `${this.query || ''}`.trim();
        const title = `${this.advancedArticleTitle || this.advancedTitle || ''}`.trim();
        const content = `${this.advancedContent || ''}`.trim();
        const itemId = `${this.advancedId || ''}`.trim();
        const publisher = `${this.publisherFilter || ''}`.trim();
        return {
            page: this.currentPage,
            dump: this.validPageSize(this.pageSize),
            sort: this.sortKey,
            query: scopedQuery,
            category: this.selectedCategories.length > 0 ? "" : this.activeCategory,
            categories: this.selectedCategories.length > 0 ? JSON.stringify(this.selectedCategories) : "",
            title,
            content,
            item_id: itemId,
            publisher,
            index_query: this.indexExpressionApplied,
            index_types: this.advancedIndexTypes.length > 0
                ? JSON.stringify(this.advancedIndexTypes)
                : "",
            subject_query: `${this.advancedSubjectQuery || ""}`.trim(),
            sender: this.advancedSender,
            era: this.eraFilter,
            file_type: this.fileTypeFilter,
            pdf: this.pdfFilter,
            visibility: (
                this.canFilterVisibility()
                && this.visibilityFilter !== "all"
            ) ? this.visibilityFilter : "",
            source: this.advancedDirectorySource,
            organization: this.advancedDirectoryOrganization,
            date_from: this.normalizeDateBoundary(this.advancedDateFrom, 'start'),
            date_to: this.normalizeDateBoundary(this.advancedDateTo, 'end'),
            node: this.nodeFilter === 'all' ? '' : this.nodeFilter,
            result_unit: this.resultUnitFilter,
            scope_level: this.scopeLevelFilter,
        };
    }

    private escapeHtml(value: any) {
        return `${value == null ? "" : value}`
            .replace(/&/g, "&amp;")
            .replace(/</g, "&lt;")
            .replace(/>/g, "&gt;")
            .replace(/"/g, "&quot;")
            .replace(/'/g, "&#39;");
    }

    public highlightHtml(value: any, sourceRanges: any) {
        const characters = Array.from(`${value == null ? "" : value}`);
        const ranges = (Array.isArray(sourceRanges) ? sourceRanges : [])
            .map((range: any) => ({
                start: Math.max(0, Math.floor(Number(range && range.start))),
                end: Math.min(
                    characters.length,
                    Math.floor(Number(range && range.end))
                )
            }))
            .filter((range: any) =>
                Number.isFinite(range.start)
                && Number.isFinite(range.end)
                && range.end > range.start
            )
            .sort((left: any, right: any) =>
                left.start - right.start || left.end - right.end
            );
        const output: string[] = [];
        let cursor = 0;
        ranges.forEach((range: any) => {
            if (range.start < cursor || range.start >= characters.length) return;
            output.push(this.escapeHtml(characters.slice(cursor, range.start).join("")));
            output.push("<mark>");
            output.push(this.escapeHtml(characters.slice(range.start, range.end).join("")));
            output.push("</mark>");
            cursor = range.end;
        });
        output.push(this.escapeHtml(characters.slice(cursor).join("")));
        return output.join("");
    }

    public searchProgressTitle() {
        const keyword = `${this.currentSearchKeyword() || ""}`.trim();
        return keyword
            ? `“${keyword}” 검색 중입니다`
            : "자료를 불러오는 중입니다";
    }

    public searchProgressLabel() {
        const labels = [
            "검색 조건을 확인하고 있습니다.",
            "등록자료와 XML 자료에서 결과를 찾고 있습니다.",
            "의미 유사 결과와 하이라이트를 정리하고 있습니다."
        ];
        return labels[this.searchProgressStep] || labels[0];
    }

    private startSearchProgress() {
        this.stopSearchProgress();
        this.searchProgressStep = 0;
        this.searchElapsedSeconds = 0;
        const startedAt = Date.now();
        this.searchProgressTimer = setInterval(async () => {
            if (!this.loading) {
                this.stopSearchProgress();
                return;
            }
            this.searchElapsedSeconds = Math.max(
                1,
                Math.floor((Date.now() - startedAt) / 1000)
            );
            this.searchProgressStep = this.searchElapsedSeconds >= 5
                ? 2
                : (this.searchElapsedSeconds >= 2 ? 1 : 0);
            await this.service.render();
        }, 1000);
    }

    private stopSearchProgress() {
        if (this.searchProgressTimer !== null) {
            clearInterval(this.searchProgressTimer);
            this.searchProgressTimer = null;
        }
    }

    private redirectToLogin() {
        if (this.authRedirecting) return;
        this.authRedirecting = true;
        this.libraryRequestSequence += 1;
        this.stopSearchProgress();
        this.service.auth.clear();
        location.replace('/login');
    }

    private async fetchLibraryPage(render: boolean = true) {
        this.pageSize = this.validPageSize(this.pageSize);
        const requestSequence = ++this.libraryRequestSequence;
        const params = this.libraryParams();
        this.loading = true;
        this.searchError = "";
        this.startSearchProgress();
        if (render) await this.service.render();
        try {
            const { code, data } = await wiz.call("library", params);
            if (requestSequence !== this.libraryRequestSequence) return;
            if (code === 401) {
                this.redirectToLogin();
                return;
            }
            if (code === 200) {
                const facets = data.facets || {};
                this.summary = data.summary || {};
                this.searchStatus = data.search || {};
                this.totalResults = Number(data.total || 0);
                this.items = Array.isArray(data.items) ? data.items : [];
                this.filteredItems = this.items;
                this.displayItems = this.items;
                this.sourceOptions = Array.isArray(facets.sources) ? facets.sources : [];
                this.organizationOptions = Array.isArray(facets.organizations) ? facets.organizations : [];
                this.eraOptions = Array.isArray(facets.eras) ? facets.eras : [];
                this.fileTypeOptions = Array.isArray(facets.file_types) ? facets.file_types : [];
                if (Array.isArray(facets.index_types)) {
                    const byId: any = {};
                    facets.index_types.forEach((row: any) => {
                        if (row && row.id) byId[row.id] = row;
                    });
                    const mappingById: any = {};
                    (Array.isArray(facets.index_type_mapping)
                        ? facets.index_type_mapping
                        : []
                    ).forEach((row: any) => {
                        if (row && row.id) mappingById[row.id] = row;
                    });
                    this.indexTypeOptions = this.indexTypeOptions.map((row: any) => ({
                        ...row,
                        ...(mappingById[row.id] || {}),
                        ...(byId[row.id] || {})
                    }));
                }
                const categoryValues = Object.keys(facets.categories || {});
                const preservedCategories = [
                    this.activeCategory,
                    this.advancedDirectoryCategory,
                    ...this.selectedCategories
                ].filter((value: string) => Boolean(value));
                this.categories = Array.from(new Set([
                    ...categoryValues,
                    ...preservedCategories
                ]));
                this.currentPage = Number(data.page || this.currentPage || 1);
                this.lastAppliedQuery = `${params.query || ""}`.trim();
                this.resultsAnimationFlip = !this.resultsAnimationFlip;
                this.syncSearchState();
            } else {
                this.searchError = (data && data.message) || "검색 결과를 불러오지 못했습니다.";
                this.searchStatus = {};
                this.items = [];
                this.filteredItems = [];
                this.displayItems = [];
                this.totalResults = 0;
            }
        } catch (error) {
            if (requestSequence !== this.libraryRequestSequence) return;
            this.searchError = "검색 서버에 연결하지 못했습니다. 잠시 후 다시 시도해주세요.";
            this.searchStatus = {};
            this.items = [];
            this.filteredItems = [];
            this.displayItems = [];
            this.totalResults = 0;
        } finally {
            if (
                requestSequence === this.libraryRequestSequence
                && !this.authRedirecting
            ) {
                this.loading = false;
                this.libraryReady = true;
                this.stopSearchProgress();
                if (render) await this.service.render();
            }
        }
    }

    private resetSearchFilters() {
        this.cancelCategorySelectionTimer();
        this.query = "";
        this.advancedTitle = "";
        this.advancedId = "";
        this.advancedPublisher = "";
        this.resetAdvancedFields();
        this.publisherFilter = "";
        this.nodeFilter = "all";
        this.eraFilter = "";
        this.fileTypeFilter = "";
        this.pdfFilter = "";
        this.visibilityFilter = "all";
        this.resultUnitFilter = "item";
        this.scopeLevelFilter = "all";
        this.metadataFilterMode = "AND";
        this.activeCategory = "";
        this.selectedCategories = [];
        this.withinResults = false;
        this.filterPanelOpen = false;
        this.activeFilterSection = "";
        this.activeMetadataDropdown = "";
        this.lastAppliedQuery = "";
    }

    public async clearSearch() {
        this.resetSearchFilters();
        this.clearSearchStateUrl();
        await this.applySearch();
    }

    public async clearQuery() {
        this.query = "";
        this.advancedAll = "";
        await this.applySearch();
    }

    public async toggleFilterPanel() {
        this.filterPanelOpen = !this.filterPanelOpen;
        await this.service.render();
    }

    public async toggleFilterSection(section: string) {
        this.activeMetadataDropdown = "";
        this.activeFilterSection = this.activeFilterSection === section ? "" : section;
        await this.service.render();
    }

    public metadataDropdownOptions(kind: string) {
        if (kind === "era") {
            return [{ value: "", label: "전체 시대" }, ...this.eraOptions.map((value: string) => ({ value, label: value }))];
        }
        if (kind === "fileType") {
            return [{ value: "", label: "전체 유형" }, ...this.fileTypeOptions.map((value: string) => ({ value, label: value.toUpperCase() }))];
        }
        return [
            { value: "", label: "전체" },
            { value: "pdf", label: "PDF만" },
            { value: "non-pdf", label: "PDF 제외" }
        ];
    }

    public metadataDropdownValue(kind: string) {
        if (kind === "era") return this.eraFilter;
        if (kind === "fileType") return this.fileTypeFilter;
        return this.pdfFilter;
    }

    public metadataDropdownLabel(kind: string) {
        const value = this.metadataDropdownValue(kind);
        const option = this.metadataDropdownOptions(kind).find((row: any) => row.value === value);
        return option ? option.label : "전체";
    }

    public async toggleMetadataDropdown(kind: string, event?: Event) {
        if (event) event.stopPropagation();
        this.accountMenuOpen = false;
        this.categoryMenuOpen = false;
        this.activeMetadataDropdown = this.activeMetadataDropdown === kind ? "" : kind;
        await this.service.render();
    }

    public async selectMetadataOption(kind: string, value: string, event?: Event) {
        if (event) event.stopPropagation();
        if (kind === "era") this.eraFilter = value;
        else if (kind === "fileType") this.fileTypeFilter = value;
        else this.pdfFilter = value;
        this.activeMetadataDropdown = "";
        await this.applySearch();
    }

    public filterSectionValue(section: string) {
        if (section === "visibility") return this.visibilityFilterLabel();
        if (section === "metadata") {
            const count = [this.eraFilter, this.fileTypeFilter, this.pdfFilter].filter(Boolean).length;
            return count > 0 ? `${count}개 적용` : "전체";
        }
        if (section === "publisher") return this.publisherFilter || "전체";
        if (section === "node") return this.nodeFilterLabel() || "전체";
        if (section === "categories") {
            return this.selectedCategories.length > 0 ? `${this.selectedCategories.length}개 선택` : "전체";
        }
        return "전체";
    }

    public activeFilterCount() {
        const filters = [
            this.query,
            this.activeCategory || (this.selectedCategories.length > 0 ? "categories" : ""),
            this.publisherFilter,
            this.eraFilter,
            this.fileTypeFilter,
            this.pdfFilter,
            (
                this.canFilterVisibility()
                && this.visibilityFilter !== "all"
            ) ? this.visibilityFilter : "",
            this.nodeFilter !== "all" ? this.nodeFilter : "",
            this.resultUnitFilter !== "item" ? this.resultUnitFilter : "",
            this.scopeLevelFilter !== "all" ? this.scopeLevelFilter : "",
            this.withinResults ? "within" : "",
            this.currentAdvancedFilterLabel()
        ];
        return filters.filter(Boolean).length;
    }

    public currentAdvancedFilterLabel() {
        const values = [
            this.advancedAll,
            this.advancedArticleTitle,
            this.advancedContent,
            this.indexExpressionApplied,
            this.advancedIndexTypes.length > 0 ? "index-types" : "",
            this.advancedSubjectQuery,
            this.advancedSender,
            this.advancedDateFrom,
            this.advancedDateTo,
            this.advancedDirectoryCategory,
            this.advancedDirectorySource,
            this.advancedDirectoryOrganization,
            this.advancedId,
            this.advancedPublisher,
            this.booleanRows.some((row: any) => `${row.keyword || ""}`.trim()) ? "boolean" : ""
        ];
        return values.some((value: string) => `${value || ""}`.trim()) ? "상세검색" : "";
    }

    public nodeFilterLabel() {
        if (this.nodeFilter === "small") return "목차 100개 미만";
        if (this.nodeFilter === "medium") return "목차 100~999개";
        if (this.nodeFilter === "large") return "목차 1,000개 이상";
        return "";
    }

    public canFilterVisibility() {
        const session = this.service.auth.session || {};
        return session.role === "admin";
    }

    public visibilityFilterLabel() {
        const option = this.visibilityOptions.find(
            (row: any) => row.value === this.visibilityFilter
        );
        return option ? option.label : "전체";
    }

    public async setVisibilityFilter(value: string) {
        this.visibilityFilter = ["all", "published", "draft"].includes(value)
            ? value
            : "all";
        await this.applySearch();
    }

    public async clearFilter(filter: string) {
        if (filter === "query") this.query = "";
        if (filter === "category") {
            this.cancelCategorySelectionTimer();
            this.activeCategory = "";
            this.selectedCategories = [];
        }
        if (filter === "publisher") {
            this.publisherFilter = "";
            this.advancedPublisher = "";
        }
        if (filter === "era") this.eraFilter = "";
        if (filter === "fileType") this.fileTypeFilter = "";
        if (filter === "pdf") this.pdfFilter = "";
        if (filter === "visibility") this.visibilityFilter = "all";
        if (filter === "node") this.nodeFilter = "all";
        if (filter === "within") this.withinResults = false;
        if (filter === "advanced") {
            if (this.query === this.booleanExpressionApplied) this.query = "";
            this.resetAdvancedFields();
        }
        await this.applySearch();
    }

    public isIndexTypeSelected(typeId: string) {
        return this.advancedIndexTypes.includes(typeId);
    }

    public async toggleIndexType(typeId: string, checked: boolean) {
        const selected = new Set(this.advancedIndexTypes);
        if (checked) selected.add(typeId);
        else selected.delete(typeId);
        this.advancedIndexTypes = Array.from(selected);
        await this.service.render();
    }

    public async selectCategory(category: string) {
        this.cancelCategorySelectionTimer();
        this.categoryMenuOpen = false;
        this.selectedCategories = [];
        this.activeCategory = category;
        await this.applySearch();
    }

    public async selectCategoryFromMenu(category: string, event?: Event) {
        if (event) event.stopPropagation();
        if (!category) {
            this.cancelCategorySelectionTimer();
            this.activeCategory = "";
            this.selectedCategories = [];
            await this.applySearch();
            return;
        }
        await this.toggleCategorySelection(category, !this.isCategorySelected(category));
    }

    public isCategorySelected(category: string) {
        return this.activeCategory === category || this.selectedCategories.includes(category);
    }

    public async toggleCategorySelection(category: string, checked: boolean) {
        const selected = new Set(this.selectedCategories);
        if (this.activeCategory && selected.size === 0) selected.add(this.activeCategory);
        if (checked) selected.add(category);
        else selected.delete(category);
        this.selectedCategories = Array.from(selected);
        this.activeCategory = "";
        if (this.categorySelectionTimer) clearTimeout(this.categorySelectionTimer);
        this.categorySelectionTimer = setTimeout(async () => {
            this.categorySelectionTimer = null;
            await this.applySearch();
        }, 220);
        await this.service.render();
    }

    public async clearCategorySelection() {
        if (this.selectedCategories.length === 0 && !this.activeCategory) return;
        this.cancelCategorySelectionTimer();
        this.selectedCategories = [];
        this.activeCategory = "";
        await this.applySearch();
    }

    public async selectAllCategories() {
        this.cancelCategorySelectionTimer();
        this.selectedCategories = [...this.availableCategories()];
        this.activeCategory = "";
        await this.applySearch();
    }

    private cancelCategorySelectionTimer() {
        if (!this.categorySelectionTimer) return;
        clearTimeout(this.categorySelectionTimer);
        this.categorySelectionTimer = null;
    }

    public async setNodeFilter(value: string) {
        this.nodeFilter = value;
        await this.applySearch();
    }

    public async metadataFilterChanged() {
        await this.applySearch();
    }

    public itemEra(item: any) {
        if (item && item.era) return `${item.era}`.trim();
        const issued = `${item && item.issued ? item.issued : ''}`;
        const yearMatch = issued.match(/(\d{4})/);
        if (!yearMatch) return "미상";
        const year = Number(yearMatch[1]);
        if (year < 1392) return "고려 이전";
        if (year < 1897) return "조선";
        if (year < 1910) return "대한제국";
        if (year < 1945) return "일제강점기";
        return "현대";
    }

    public itemFileType(item: any) {
        const explicit = `${item && item.file_type ? item.file_type : ''}`.toLowerCase();
        if (explicit) return explicit;
        if (item && item.xml_path) return "xml";
        return "기타";
    }

    public itemVisibilityStatus(item: any) {
        const status = `${item && item.status ? item.status : ''}`.trim().toLowerCase();
        if (status === "published") return "published";
        if (status === "draft") return "draft";
        return item && item.registered ? "draft" : "published";
    }

    public visibilityLabel(item: any) {
        return this.itemVisibilityStatus(item) === "published" ? "공개" : "비공개";
    }

    public visibilityBadgeClass(item: any) {
        return this.itemVisibilityStatus(item) === "published"
            ? "is-public"
            : "is-private";
    }

    private matchesMetadataFilters(item: any) {
        const checks: boolean[] = [];
        if (this.eraFilter) checks.push(this.itemEra(item) === this.eraFilter);
        if (this.fileTypeFilter) checks.push(this.itemFileType(item) === this.fileTypeFilter);
        if (this.pdfFilter === "pdf") checks.push(!!item.is_pdf || this.itemFileType(item) === "pdf");
        if (this.pdfFilter === "non-pdf") checks.push(!item.is_pdf && this.itemFileType(item) !== "pdf");
        if (checks.length === 0) return true;
        return this.metadataFilterMode === "OR" ? checks.some(Boolean) : checks.every(Boolean);
    }

    public async setViewMode(mode: string) {
        const nextMode = mode === "cover" ? "cover" : "list";
        this.rememberCurrentPageSize();
        this.viewMode = nextMode;
        this.pageSize = this.validPageSize(this.pageSizeByViewMode[this.viewMode], this.viewMode);
        await this.applySearch();
    }

    public async onPageSizeChange() {
        this.pageSize = this.validPageSize(this.pageSize);
        this.pageSizeByViewMode[this.viewMode] = this.pageSize;
        await this.applySearch();
    }

    public async onSortChange() {
        await this.applySearch();
    }

    public async setPage(page: number) {
        if (this.loading) return;
        const nextPage = this.clampedPage(page);
        if (nextPage === this.currentPage) return;
        this.clearSelection();
        this.currentPage = nextPage;
        this.paginationLoadingPage = nextPage;
        this.syncSearchState();
        await this.service.render();
        try {
            await this.fetchLibraryPage(true);
        } finally {
            this.paginationLoadingPage = null;
            await this.service.render();
        }
    }

    public canDeleteItems() {
        return this.canFilterVisibility()
            && this.resultUnitFilter === "representative";
    }

    public canViewVersionHistory() {
        const session = this.service.auth.session || {};
        return session.role === "admin"
            && !!(this.selectedItem && this.selectedItem.registered)
            && Array.isArray(this.documentDetail && this.documentDetail.versionHistory);
    }

    public itemSelectionKey(item: any) {
        const type = item && item.registered ? "registered" : "catalog";
        const identity = item && (
            item.hierarchy_unit_id || item.itemId || item.id
        );
        return `${type}:${identity || ""}`;
    }

    public trackByLibraryItem(index: number, item: any) {
        const itemId = item && (
            item.hierarchy_unit_id || item.itemId || item.id
        );
        if (!itemId) return `row:${index}`;
        const type = item.registered ? "registered" : "catalog";
        return `${type}:${itemId}`;
    }

    public isItemSelected(item: any) {
        return this.selectedItemKeys.indexOf(this.itemSelectionKey(item)) >= 0;
    }

    public isCurrentPageSelected() {
        return this.displayItems.length > 0
            && this.displayItems.every((item: any) => this.isItemSelected(item));
    }

    public async toggleItemSelection(item: any, event?: any) {
        if (event && event.stopPropagation) event.stopPropagation();
        const key = this.itemSelectionKey(item);
        if (!key.endsWith(":")) {
            if (this.selectedItemKeys.indexOf(key) >= 0) {
                this.selectedItemKeys = this.selectedItemKeys.filter((value: string) => value !== key);
            } else {
                this.selectedItemKeys = [...this.selectedItemKeys, key];
            }
        }
        await this.service.render();
    }

    public async toggleCurrentPageSelection(checked: boolean) {
        const currentKeys = this.displayItems.map((item: any) => this.itemSelectionKey(item));
        if (checked) {
            this.selectedItemKeys = Array.from(new Set([...this.selectedItemKeys, ...currentKeys]));
        } else {
            this.selectedItemKeys = this.selectedItemKeys.filter((key: string) => currentKeys.indexOf(key) < 0);
        }
        await this.service.render();
    }

    public async deleteSelectedItems() {
        if (!this.canDeleteItems() || this.deletingSelection || this.selectedItemKeys.length === 0) return;
        const selectedItems = this.displayItems.filter((item: any) => this.isItemSelected(item));
        if (selectedItems.length === 0) return;

        this.deleteDialogItems = selectedItems.map((item: any) => ({
            id: `${item.itemId || item.id || ""}`,
            registered: !!item.registered,
            title: this.displayTitle(item),
            subtitle: this.displaySubtitle(item),
            category: item.category || "기타",
            status: this.itemVisibilityStatus(item)
        }));
        this.deleteDialogPhase = "confirm";
        this.deleteDialogFailures = [];
        this.deleteDialogWarnings = [];
        this.deleteDialogError = "";
        this.deleteDialogDeleted = 0;
        this.deleteDialogAlreadyDeleted = 0;
        this.deleteDialogRequestId = "";
        this.deleteDialogOpen = true;
        await this.service.render();
    }

    public async closeDeleteDialog() {
        if (this.deletingSelection || this.deleteDialogPhase === "processing") return;
        const refreshAfterClose = (
            this.deleteDialogPhase === "result"
            && (
                this.deleteDialogDeleted > 0
                || this.deleteDialogAlreadyDeleted > 0
            )
        );
        this.deleteDialogOpen = false;
        this.deleteDialogItems = [];
        this.deleteDialogFailures = [];
        this.deleteDialogWarnings = [];
        this.deleteDialogError = "";
        await this.service.render();
        if (refreshAfterClose) location.reload();
    }

    public deleteDialogCount(registered: boolean) {
        return this.deleteDialogItems.filter(
            (item: any) => !!item.registered === registered
        ).length;
    }

    public deleteDialogVisibilityCount(status: string) {
        return this.deleteDialogItems.filter(
            (item: any) => item.status === status
        ).length;
    }

    public deleteDialogPreviewItems() {
        return this.deleteDialogItems.slice(0, 5);
    }

    public deleteDialogRemainingCount() {
        return Math.max(0, this.deleteDialogItems.length - 5);
    }

    public deleteIssueTitle(issue: any) {
        const target = this.deleteDialogItems.find(
            (item: any) => (
                item.id === `${issue && issue.id ? issue.id : ""}`
                && !!item.registered === !!(issue && issue.registered)
            )
        );
        return target ? target.title : `${issue && issue.id ? issue.id : "알 수 없는 자료"}`;
    }

    public async retryFailedDeletion() {
        if (this.deleteDialogFailures.length === 0 || this.deletingSelection) return;
        const failedKeys = new Set(
            this.deleteDialogFailures.map((failure: any) => this.deleteTargetKey(failure))
        );
        this.deleteDialogItems = this.deleteDialogItems.filter(
            (item: any) => failedKeys.has(this.deleteTargetKey(item))
        );
        this.deleteDialogPhase = "confirm";
        this.deleteDialogFailures = [];
        this.deleteDialogWarnings = [];
        this.deleteDialogError = "";
        this.deleteDialogDeleted = 0;
        this.deleteDialogAlreadyDeleted = 0;
        await this.service.render();
        await this.confirmSelectedDeletion();
    }

    private deleteTargetKey(target: any) {
        return `${target && target.registered ? "registered" : "catalog"}:${target && target.id ? target.id : ""}`;
    }

    public async confirmSelectedDeletion() {
        if (
            !this.canDeleteItems()
            || this.deletingSelection
            || this.deleteDialogItems.length === 0
        ) return;

        this.deletingSelection = true;
        this.deleteDialogPhase = "processing";
        this.deleteDialogFailures = [];
        this.deleteDialogWarnings = [];
        this.deleteDialogError = "";
        await this.service.render();
        try {
            const targets = this.deleteDialogItems.map((item: any) => ({
                id: item.id,
                registered: item.registered
            }));
            const { code, data } = await wiz.call("delete_items", { targets: JSON.stringify(targets) });
            if (code === 401) {
                this.redirectToLogin();
                return;
            }
            const failures = data && Array.isArray(data.failures) ? data.failures : [];
            const warnings = data && Array.isArray(data.warnings) ? data.warnings : [];
            const deletedTargets = data && Array.isArray(data.deleted_targets)
                ? data.deleted_targets
                : [];
            this.deleteDialogFailures = failures;
            this.deleteDialogWarnings = warnings;
            this.deleteDialogDeleted = Number((data && data.deleted) || 0);
            this.deleteDialogAlreadyDeleted = Number((data && data.already_deleted) || 0);
            this.deleteDialogRequestId = `${data && data.request_id ? data.request_id : ""}`;

            const completedKeys = new Set(
                deletedTargets.map((target: any) => this.deleteTargetKey(target))
            );
            if (completedKeys.size > 0) {
                this.selectedItemKeys = this.selectedItemKeys.filter(
                    (key: string) => !completedKeys.has(key)
                );
                await this.fetchLibraryPage(false);
                const lastPage = Math.max(1, Math.ceil(this.totalResults / this.pageSize));
                if (this.currentPage > lastPage) {
                    this.currentPage = lastPage;
                    await this.fetchLibraryPage(false);
                }
            }

            if (code !== 200 && deletedTargets.length === 0) {
                this.deleteDialogPhase = "error";
                this.deleteDialogError = (
                    (data && data.message)
                    || "선택한 자료를 삭제하지 못했습니다. 잠시 후 다시 시도해주세요."
                );
                return;
            }
            this.deleteDialogPhase = "result";
        } catch (error) {
            this.deleteDialogPhase = "error";
            this.deleteDialogError = "삭제 요청 결과를 확인하지 못했습니다. 선택 항목은 유지했으니 다시 시도해주세요.";
        } finally {
            this.deletingSelection = false;
            if (!this.authRedirecting) await this.service.render();
        }
    }

    public async toggleAdvanced() {
        if (!this.advancedOpen) {
            this.advancedAll = this.query;
            this.advancedPublisher = this.publisherFilter;
            this.advancedDirectoryCategory = (
                this.selectedCategories.length === 0
                    ? this.activeCategory
                    : ""
            );
        }
        this.advancedOpen = !this.advancedOpen;
        await this.service.render();
    }

    public async addBooleanRow() {
        this.booleanRows.push({ operator: "AND", keyword: "" });
        await this.service.render();
    }

    public async removeBooleanRow(index: number) {
        if (this.booleanRows.length <= 1) {
            this.booleanRows[0] = { operator: "AND", keyword: "" };
        } else {
            this.booleanRows.splice(index, 1);
        }
        await this.service.render();
    }

    public buildBooleanExpression() {
        return this.buildRowsExpression(this.booleanRows);
    }

    public async addIndexRow() {
        this.indexRows.push({ operator: "AND", keyword: "" });
        await this.service.render();
    }

    public async removeIndexRow(index: number) {
        if (this.indexRows.length <= 1) {
            this.indexRows[0] = { operator: "AND", keyword: "" };
        } else {
            this.indexRows.splice(index, 1);
        }
        await this.service.render();
    }

    public buildIndexExpression() {
        return this.buildRowsExpression(this.indexRows);
    }

    private buildRowsExpression(sourceRows: any[]) {
        const rows = sourceRows
            .map((row: any) => ({
                operator: `${row.operator || "AND"}`.toUpperCase(),
                keyword: `${row.keyword || ""}`.trim()
            }))
            .filter((row: any) => row.keyword);
        if (rows.length === 0) return "";
        const values: string[] = [];
        rows.forEach((row: any, index: number) => {
            const keyword = this.booleanKeyword(row.keyword);
            if (index === 0) {
                values.push(row.operator === "NOT" ? `NOT ${keyword}` : keyword);
                return;
            }
            values.push(
                row.operator === "NOT"
                    ? `NOT ${keyword}`
                    : `${row.operator === "OR" ? "OR" : "AND"} ${keyword}`
            );
        });
        return values.join(" ");
    }

    public async closeAdvanced() {
        this.advancedOpen = false;
        await this.service.render();
    }

    public async resetAdvancedSearch() {
        this.resetAdvancedFields();
        await this.service.render();
    }

    public async openInfoPanel(panel: string) {
        this.infoPanel = panel;
        await this.service.render();
    }

    public async closeInfoPanel() {
        this.infoPanel = "";
        await this.service.render();
    }

    public async applyPopular(keyword: string) {
        this.query = keyword;
        this.infoPanel = "";
        await this.runSearch();
    }

    public async applyHistory(keyword: string) {
        this.query = keyword;
        this.infoPanel = "";
        await this.runSearch();
    }

    public async clearHistory() {
        this.searchHistory = [];
        this.saveSearchHistory();
        await this.service.render();
    }

    public async openDetail(item: any) {
        this.selectedItem = item;
        this.detailOpen = true;
        this.detailLoading = true;
        this.detailTab = "summary";
        this.detailXml = "";
        this.documentDetail = {};
        this.citationCopied = false;
        this.syncScrapState(item);
        await this.service.render();

        const { code, data } = await wiz.call("document", {
            itemId: item.itemId || item.id,
            unitPath: item.unit_path || "",
            limit: 16000
        });
        if (code === 401) {
            this.redirectToLogin();
            return;
        }
        if (code === 200) {
            this.detailXml = data.xml || "";
            this.selectedItem = data.item || item;
            this.documentDetail = data.detail || {};
            this.syncScrapState(this.selectedItem);
        } else {
            this.detailXml = "XML 원문을 불러오지 못했습니다.";
            this.documentDetail = {};
        }
        this.detailLoading = false;
        await this.service.render();
    }

    public async closeDetail() {
        this.detailOpen = false;
        this.selectedItem = null;
        this.detailXml = "";
        this.documentDetail = {};
        this.detailLoading = false;
        this.detailTab = "summary";
        this.scrapMemo = "";
        this.citationCopied = false;
        await this.service.render();
    }

    public async setDetailTab(tab: string) {
        this.detailTab = tab;
        await this.service.render();
    }

    public detailBiblio() {
        return (this.documentDetail && this.documentDetail.biblio) || {};
    }

    public detailRights() {
        return (this.documentDetail && this.documentDetail.rights) || {};
    }

    public detailStats() {
        return (this.documentDetail && this.documentDetail.stats) || {};
    }

    public detailContentLayers() {
        const value = (
            this.documentDetail && this.documentDetail.contentLayers
        ) || {};
        return value && typeof value === "object" ? value : {};
    }

    public detailContentLayerRows() {
        const rows = this.detailContentLayers().chunks || [];
        return Array.isArray(rows) ? rows : [];
    }

    public contentLayerCount(layer: string) {
        const counts = this.detailContentLayers().counts || {};
        return Number(counts[layer] || 0);
    }

    public contentLayerLabel(layer: any) {
        const labels: any = {
            primary_original: "1차 사료 원문",
            primary_translation: "1차 사료 번역문",
            commentary: "사료해설",
            metadata: "서지정보",
            unclassified: "미분류"
        };
        return labels[`${layer || ""}`] || "미분류";
    }

    public verificationStatusLabel(status: any) {
        const labels: any = {
            verified: "검증됨",
            review_required: "검수 필요",
            unverified: "미검증",
            ambiguous: "모호함"
        };
        return labels[`${status || ""}`] || "검수 필요";
    }

    public contentLayerLinkLabel(row: any) {
        if (row && row.linkedOriginalChunkId) {
            return `원문 ${row.linkedOriginalChunkId}`;
        }
        const translations = (
            row && Array.isArray(row.linkedTranslationChunkIds)
        ) ? row.linkedTranslationChunkIds : [];
        if (translations.length > 0) {
            return `번역문 ${translations.length}건`;
        }
        return "해당 없음";
    }

    public detailToc() {
        const toc = (this.documentDetail && this.documentDetail.toc) || [];
        return Array.isArray(toc) ? toc : [];
    }

    public detailTranslation() {
        const translation = (
            this.documentDetail && this.documentDetail.translation
        ) || {};
        return translation && typeof translation === "object"
            ? translation : {};
    }

    public detailTranslationRows() {
        const rows = this.detailTranslation().rows || [];
        return Array.isArray(rows) ? rows : [];
    }

    public detailTranslationAvailable() {
        return !!(
            this.detailTranslationRows().length > 0
            || this.detailTranslation().sourceAvailable
        );
    }

    public detailTranslationCanManage() {
        return !!this.detailTranslation().canManage;
    }

    public detailTranslationStatusLabel(row: any) {
        const labels: any = {
            complete: "번역 완료",
            not_required: "번역 불필요",
            review_required: "검토 필요"
        };
        return labels[`${row && row.status || ""}`] || "검토 필요";
    }

    public detailVersionHistory() {
        const history = (this.documentDetail && this.documentDetail.versionHistory) || [];
        return Array.isArray(history) ? history : [];
    }

    public isLatestVersion(version: any) {
        const history = this.detailVersionHistory();
        return history.length > 0 && Number(history[0].version) === Number(version);
    }

    public versionStateLabel(state: any) {
        const labels: any = {
            READY: "등록 완료",
            BUILDING: "처리 중",
            SNAPSHOT_COMMITTED: "원본 저장 완료",
            INDEX_PENDING: "검색 반영 중",
            FAILED: "처리 실패",
            CANCELLED: "취소됨"
        };
        const key = `${state || ""}`.toUpperCase();
        return labels[key] || key || "상태 없음";
    }

    public versionReasonText(entry: any) {
        if (entry && `${entry.reason || ""}`.trim()) return entry.reason;
        if (Number(entry && entry.version) === 1) return "최초 등록";
        return "등록 사유가 기록되지 않은 이전 버전입니다.";
    }

    public versionRegistrantText(entry: any) {
        const name = `${entry && entry.requestedByName ? entry.requestedByName : ""}`.trim();
        const id = `${entry && entry.requestedBy ? entry.requestedBy : ""}`.trim();
        if (name && id && name !== id) return `${name} (${id})`;
        return name || id || "정보 없음";
    }

    public originalText() {
        const samples = (this.documentDetail && this.documentDetail.samples) || {};
        return samples.originalText || "";
    }

    public introductionText() {
        const samples = (this.documentDetail && this.documentDetail.samples) || {};
        return samples.frontText || (this.selectedItem ? this.selectedItem.preview : "") || "";
    }

    public creatorText() {
        const creators = this.detailBiblio().creators || [];
        if (Array.isArray(creators) && creators.length > 0) return creators.join(", ");
        return "정보 없음";
    }

    public seriesText() {
        const biblio = this.detailBiblio();
        const parts = [biblio.seriesTitle, biblio.seriesVolume ? `제${biblio.seriesVolume}권` : ""].filter(Boolean);
        return parts.length > 0 ? parts.join(" ") : "정보 없음";
    }

    public formatDateTime(value: any) {
        const raw = `${value || ""}`;
        if (!raw) return "정보 없음";
        const date = new Date(raw);
        if (isNaN(date.getTime())) return raw;
        const year = date.getFullYear();
        const month = `${date.getMonth() + 1}`.padStart(2, "0");
        const day = `${date.getDate()}`.padStart(2, "0");
        const hour = `${date.getHours()}`.padStart(2, "0");
        const minute = `${date.getMinutes()}`.padStart(2, "0");
        return `${year}. ${month}. ${day}. ${hour}:${minute}`;
    }

    public rightsText(kind: string) {
        const rights = this.detailRights();
        const value = rights[kind];
        if (!value) return "정보 없음";
        if (kind === "commercial") return value === "nc" ? "비영리 이용" : value;
        if (kind === "modification") return value === "nd" ? "변경 금지" : value;
        if (kind === "source") return value === "Y" ? "출처 표시" : value;
        if (kind === "by") return value === "Y" ? "저작자 표시" : value;
        return value;
    }

    public currentScrap() {
        if (!this.selectedItem) return null;
        const itemId = this.selectedItem.itemId || this.selectedItem.id;
        return this.scrapbook.find((row: any) => row.itemId === itemId) || null;
    }

    public isScrapped(item: any) {
        if (!item) return false;
        const itemId = item.itemId || item.id;
        return this.scrapbook.some((row: any) => row.itemId === itemId);
    }

    public scrapStatusLabel() {
        return this.currentScrap() ? "스크랩 저장됨" : "스크랩 전";
    }

    public scrapSavedAt() {
        const scrap = this.currentScrap();
        return scrap && scrap.savedAt ? this.formatDateTime(scrap.savedAt) : "미저장";
    }

    public async toggleScrap() {
        if (!this.selectedItem) return;
        const itemId = this.selectedItem.itemId || this.selectedItem.id;
        const exists = this.currentScrap();
        if (exists) {
            this.scrapbook = this.scrapbook.filter((row: any) => row.itemId !== itemId);
            this.scrapMemo = "";
        } else {
            const now = new Date().toISOString();
            this.scrapbook = [{
                itemId,
                title: this.selectedItem.title || this.selectedItem.main_title || "자료",
                category: this.selectedItem.category || "",
                folder: this.scrapFolder || "기본 자료함",
                memo: this.scrapMemo || "",
                savedAt: now,
                updatedAt: now
            }, ...this.scrapbook].slice(0, 100);
        }
        this.saveScrapbook();
        await this.service.render();
    }

    public async saveScrapInfo() {
        if (!this.selectedItem) return;
        const itemId = this.selectedItem.itemId || this.selectedItem.id;
        let found = false;
        const now = new Date().toISOString();
        this.scrapbook = this.scrapbook.map((row: any) => {
            if (row.itemId !== itemId) return row;
            found = true;
            return {
                ...row,
                folder: this.scrapFolder || "기본 자료함",
                memo: this.scrapMemo || "",
                updatedAt: now
            };
        });
        if (!found) {
            this.scrapbook = [{
                itemId,
                title: this.selectedItem.title || this.selectedItem.main_title || "자료",
                category: this.selectedItem.category || "",
                folder: this.scrapFolder || "기본 자료함",
                memo: this.scrapMemo || "",
                savedAt: now,
                updatedAt: now
            }, ...this.scrapbook].slice(0, 100);
        }
        this.saveScrapbook();
        await this.service.render();
    }

    public citationText() {
        if (!this.selectedItem) return "";
        const biblio = this.detailBiblio();
        const creator = this.creatorText() !== "정보 없음" ? `${this.creatorText()}, ` : "";
        const title = biblio.mainTitle || this.selectedItem.main_title || this.selectedItem.title || "자료";
        const publisher = biblio.publisher || this.selectedItem.publisher || this.selectedItem.organization || "동북아역사재단";
        const issued = biblio.issued || this.selectedItem.issued || "발행일 미상";
        return `${creator}${title}, ${publisher}, ${issued}.`;
    }

    public async copyCitation() {
        const text = this.citationText();
        if (!text) return;
        try {
            if (navigator && navigator.clipboard) {
                await navigator.clipboard.writeText(text);
                this.citationCopied = true;
            }
        } catch (error) {
            this.citationCopied = false;
        }
        await this.service.render();
    }

    public downloadXml() {
        if (!this.selectedItem || !this.detailXml) return;
        const itemId = this.selectedItem.itemId || this.selectedItem.id || "document";
        const blob = new Blob([this.detailXml], { type: "application/xml;charset=utf-8" });
        const url = URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `${itemId}.xml`;
        link.click();
        URL.revokeObjectURL(url);
    }

    public categoryCount(category: string) {
        if (!category) return Number(this.summary.total || this.items.length || 0);
        const categories = this.summary.categories || {};
        return Number(categories[category] || this.items.filter((item: any) => item.category === category).length || 0);
    }

    public availableCategories() {
        return this.categories.filter((category: string) =>
            this.categoryCount(category) > 0 || category === this.activeCategory || this.selectedCategories.includes(category)
        );
    }

    public categoryLeafLabel(category: string) {
        const parts = this.categoryPathParts(category);
        return parts[parts.length - 1] || "기타";
    }

    public categoryParentLabel(category: string) {
        const parts = this.categoryPathParts(category);
        return parts.length > 1 ? parts.slice(0, -1).join(" / ") : "";
    }

    public categoryDisplayLabel(category: string) {
        const leaf = this.categoryLeafLabel(category);
        const parent = this.categoryParentLabel(category);
        return parent ? `${leaf} · ${parent}` : leaf;
    }

    private categoryPathParts(category: string) {
        return `${category || ""}`
            .split("/")
            .map((part: string) => part.trim())
            .filter((part: string) => Boolean(part));
    }

    public primaryCategoryTabs() {
        return this.availableCategories().slice(0, 6);
    }

    public overflowCategoryTabs() {
        return this.availableCategories().slice(6);
    }

    public nodeCountLabel(value: string) {
        const nodes = this.summary.nodes || {};
        if (value === "all") return Number(this.summary.total || this.totalResults || 0);
        return Number(nodes[value] || 0);
    }

    public coverTitle(item: any) {
        return (item.title || "자료").slice(0, 8);
    }

    public displayTitle(item: any) {
        return this.showHanja ? (item.title || "자료") : this.stripHanja(item.title || "자료");
    }

    public displaySubtitle(item: any) {
        const value = item.main_title || item.xml_root_name || item.title || "";
        return this.showHanja ? value : this.stripHanja(value);
    }

    public itemMeta(item: any) {
        const parts = [item.organization || "동북아역사재단"];
        if (item.issued) parts.push(item.issued);
        return parts.join("  ");
    }

    public formatBytes(value: any) {
        const bytes = Number(value);
        if (!Number.isFinite(bytes) || bytes <= 0) return "0B";
        return `${Math.trunc(bytes).toLocaleString("ko-KR")}B`;
    }

    public formatNodeCount(value: any) {
        const count = Number(value || 0);
        if (!count) return "목차 없음";
        return `${count.toLocaleString()}개 노드`;
    }

    public resultRangeText() {
        if (this.totalResults === 0) return "0건";
        const start = (this.currentPage - 1) * this.pageSize + 1;
        const end = Math.min(this.totalResults, start + this.displayItems.length - 1);
        return `${this.totalResults.toLocaleString('ko-KR')}건 중 ${start.toLocaleString('ko-KR')}-${end.toLocaleString('ko-KR')}건 표시`;
    }

    public pageSizeOptions() {
        return this.pageSizeOptionsByMode[this.viewMode] || this.pageSizeOptionsByMode.list;
    }

    public totalPages() {
        return Math.max(1, Math.ceil(this.totalResults / this.pageSize));
    }

    public paginationPages() {
        const total = this.totalPages();
        const pages: number[] = [];
        const windowSize = 5;
        let start = Math.max(1, this.currentPage - 2);
        let end = Math.min(total, start + windowSize - 1);
        start = Math.max(1, end - windowSize + 1);
        for (let page = start; page <= end; page++) pages.push(page);
        return pages;
    }

    public updatedDate() {
        const value = this.summary.generated_at || "";
        if (!value) return "";
        return value.slice(0, 10).replace(/-/g, ". ") + ".";
    }

    public async onCoverError(event: any, item?: any) {
        const fallback = "/assets/nahf/cover-fallback.svg";
        const image = event && event.target;
        if (!image || !item || item.cover_url === fallback) return;
        item.cover_url = fallback;
        await this.service.render();
    }

    private normalize(value: any) {
        return `${value || ''}`.trim().toLowerCase();
    }

    private matchesNodeFilter(item: any) {
        if (this.nodeFilter === "all") return true;
        return this.nodeBucket(item) === this.nodeFilter;
    }

    private uniqueItemValues(...keys: string[]) {
        const values: string[] = [];
        this.items.forEach((item: any) => {
            keys.forEach((key: string) => {
                const value = `${item[key] || ''}`.trim();
                if (value && values.indexOf(value) < 0) values.push(value);
            });
        });
        return values.sort((a: string, b: string) => a.localeCompare(b, "ko-KR"));
    }

    private resetAdvancedFields() {
        this.advancedTitle = "";
        this.advancedId = "";
        this.advancedPublisher = "";
        this.advancedAll = "";
        this.advancedArticleTitle = "";
        this.advancedContent = "";
        this.advancedIndexTypes = [];
        this.indexRows = [{ operator: "AND", keyword: "" }];
        this.indexExpressionApplied = "";
        this.advancedSubjectQuery = "";
        this.advancedSender = "";
        this.advancedDateFrom = "";
        this.advancedDateTo = "";
        this.advancedDirectoryCategory = "";
        this.advancedDirectorySource = "";
        this.advancedDirectoryOrganization = "";
        this.visibilityFilter = "all";
        this.booleanRows = [{ operator: "AND", keyword: "" }];
        this.booleanExpressionApplied = "";
    }

    private booleanKeyword(value: string) {
        const keyword = `${value || ""}`.trim();
        if (
            keyword
            && !/[\s()"\\]/.test(keyword)
            && !/^(AND|OR|NOT)$/i.test(keyword)
        ) {
            return keyword;
        }
        return `"${keyword.replace(/\\/g, "\\\\").replace(/"/g, '\\"')}"`;
    }

    private initializeSearchState() {
        if (this.shouldResetSearchStateOnInit()) {
            this.resetSearchFilters();
            this.clearSearchStateUrl();
            return;
        }
        this.restoreSearchState();
    }

    private shouldResetSearchStateOnInit() {
        if (Component.initialSearchStateResolved) return false;
        Component.initialSearchStateResolved = true;
        if (
            typeof performance === "undefined"
            || typeof performance.getEntriesByType !== "function"
        ) return false;
        try {
            const navigation: any = performance.getEntriesByType("navigation")[0];
            if (!navigation || navigation.type !== "reload") return false;
            const loadedUrl = new URL(`${navigation.name || ""}`, location.href);
            return loadedUrl.pathname === location.pathname;
        } catch (error) {
            return false;
        }
    }

    private clearSearchStateUrl() {
        history.replaceState(
            history.state,
            "",
            `${location.pathname}${location.hash || ""}`
        );
    }

    private restoreSearchState() {
        const params = new URLSearchParams(location.search);
        this.query = params.get("query") || "";
        this.activeCategory = params.get("category") || "";
        this.advancedArticleTitle = params.get("title") || "";
        this.advancedContent = params.get("content") || "";
        this.advancedId = params.get("item_id") || "";
        this.publisherFilter = params.get("publisher") || "";
        this.advancedPublisher = this.publisherFilter;
        this.indexExpressionApplied = (
            params.get("index_query")
            || params.get("index_keyword")
            || ""
        );
        this.advancedSubjectQuery = params.get("subject_query") || "";
        this.advancedSender = params.get("sender") || "";
        this.eraFilter = params.get("era") || "";
        this.fileTypeFilter = params.get("file_type") || "";
        this.pdfFilter = params.get("pdf") || "";
        const visibility = params.get("visibility") || "all";
        this.visibilityFilter = (
            this.canFilterVisibility()
            && ["all", "published", "draft"].includes(visibility)
        ) ? visibility : "all";
        this.advancedDirectorySource = params.get("source") || "";
        this.advancedDirectoryOrganization = params.get("organization") || "";
        this.advancedDateFrom = params.get("date_from") || "";
        this.advancedDateTo = params.get("date_to") || "";
        this.nodeFilter = params.get("node") || "all";
        const resultUnit = params.get("result_unit") || "item";
        this.resultUnitFilter = ["item", "representative", "hierarchy"].includes(resultUnit)
            ? resultUnit
            : "item";
        const scopeLevel = (params.get("scope_level") || "all").toLowerCase();
        this.scopeLevelFilter = [
            "all", "item", "level1", "level2", "level3",
            "level4", "level5", "level6"
        ].includes(scopeLevel) ? scopeLevel : "all";
        this.sortKey = params.get("sort") || this.sortKey;
        this.pageSize = this.validPageSize(Number(params.get("dump") || this.pageSize));
        this.currentPage = Math.max(1, Number(params.get("page") || 1));
        const categories = params.get("categories") || "";
        try {
            const values = categories ? JSON.parse(categories) : [];
            this.selectedCategories = Array.isArray(values) ? values : [];
        } catch (error) {
            this.selectedCategories = [];
        }
        const indexTypes = (
            params.get("index_types")
            || params.get("index_type")
            || ""
        );
        try {
            const values = indexTypes
                ? JSON.parse(indexTypes)
                : [];
            this.advancedIndexTypes = Array.isArray(values)
                ? values
                : (values ? [values] : []);
        } catch (error) {
            this.advancedIndexTypes = indexTypes
                ? indexTypes.split("|").filter(Boolean)
                : [];
        }
        this.advancedAll = this.query;
        this.advancedDirectoryCategory = (
            this.selectedCategories.length === 0
                ? this.activeCategory
                : ""
        );
    }

    private syncSearchState() {
        const params = new URLSearchParams();
        const values: any = this.libraryParams();
        Object.keys(values).forEach((key: string) => {
            const value = values[key];
            if (`${value || ""}`) params.set(key, `${value}`);
        });
        const queryString = params.toString();
        history.replaceState(
            null,
            "",
            `${location.pathname}${queryString ? `?${queryString}` : ""}${location.hash || ""}`
        );
    }

    private currentSearchKeyword() {
        return [
            this.query,
            this.advancedAll,
            this.advancedArticleTitle,
            this.advancedContent,
            this.indexExpressionApplied,
            this.advancedSender,
            this.advancedId,
            this.advancedPublisher,
            this.publisherFilter
        ].find((value: string) => `${value || ''}`.trim()) || "";
    }

    private normalizeDateBoundary(value: string, side: "start" | "end") {
        const digits = `${value || ''}`.replace(/\D/g, "");
        if (!digits) return "";
        if (digits.length >= 8) return digits.slice(0, 8);
        if (digits.length === 6) return `${digits}${side === "start" ? "01" : "31"}`;
        if (digits.length === 4) return `${digits}${side === "start" ? "0101" : "1231"}`;
        return "";
    }

    private itemDateValue(item: any) {
        const issued = `${item.issued || ''}`;
        const issuedMatch = issued.match(/(\d{4})\D+(\d{1,2})\D+(\d{1,2})/);
        if (issuedMatch) {
            return [
                issuedMatch[1],
                issuedMatch[2].padStart(2, "0"),
                issuedMatch[3].padStart(2, "0")
            ].join("");
        }

        const compact = `${item.issued || ''} ${item.fetched_at || ''}`.replace(/\D/g, "");
        if (compact.length >= 8) return compact.slice(0, 8);
        if (compact.length >= 4) return `${compact.slice(0, 4)}0101`;
        return "";
    }

    private nodeBucket(item: any) {
        const count = Number(item.node_count || 0);
        if (count >= 1000) return "large";
        if (count >= 100) return "medium";
        return "small";
    }

    public stripHanja(value: string) {
        const cleaned = `${value || ''}`
            .replace(/\([^)]*[\u3400-\u9fff][^)]*\)/g, "")
            .replace(/[\u3400-\u9fff]/g, "")
            .replace(/\s+/g, " ")
            .trim();
        return cleaned || value;
    }

    private addSearchHistory(value: string) {
        const keyword = `${value || ''}`.trim();
        if (!keyword) return;
        this.searchHistory = [keyword, ...this.searchHistory.filter((item: string) => item !== keyword)].slice(0, 8);
        this.saveSearchHistory();
    }

    private loadSearchHistory() {
        try {
            const raw = localStorage.getItem(this.historyKey);
            this.searchHistory = raw ? JSON.parse(raw) : [];
        } catch (error) {
            this.searchHistory = [];
        }
    }

    private saveSearchHistory() {
        try {
            localStorage.setItem(this.historyKey, JSON.stringify(this.searchHistory));
        } catch (error) { }
    }

    private loadScrapbook() {
        try {
            const raw = localStorage.getItem(this.scrapKey);
            const rows = raw ? JSON.parse(raw) : [];
            this.scrapbook = Array.isArray(rows) ? rows : [];
        } catch (error) {
            this.scrapbook = [];
        }
    }

    private saveScrapbook() {
        try {
            localStorage.setItem(this.scrapKey, JSON.stringify(this.scrapbook));
        } catch (error) { }
    }

    private rememberCurrentPageSize() {
        this.pageSize = this.validPageSize(this.pageSize);
        this.pageSizeByViewMode[this.viewMode] = this.pageSize;
    }

    private validPageSize(value: any, mode: string = this.viewMode) {
        const options = this.pageSizeOptionsByMode[mode] || this.pageSizeOptionsByMode.list;
        const size = Number(value || 0);
        return options.indexOf(size) >= 0 ? size : options[0];
    }

    private clampedPage(value: any) {
        const page = Math.floor(Number(value || 1));
        if (page < 1) return 1;
        return Math.min(page, this.totalPages());
    }

    private clearSelection() {
        this.selectedItemKeys = [];
    }

    private updateDisplayItems() {
        this.pageSize = this.validPageSize(this.pageSize);
        this.currentPage = this.clampedPage(this.currentPage);
        this.displayItems = this.filteredItems;
    }

    private syncScrapState(item: any) {
        if (!item) return;
        const itemId = item.itemId || item.id;
        const scrap = this.scrapbook.find((row: any) => row.itemId === itemId);
        this.scrapFolder = scrap && scrap.folder ? scrap.folder : "기본 자료함";
        this.scrapMemo = scrap && scrap.memo ? scrap.memo : "";
    }
}

export default PageHomeComponent;